/**
 * `time` translations, for every locale.
 */
export const time = {
  mn: {
      time: {
        // Батлагдаагүй удсан хүсэлтийн статус.
        backlog: {
          whySelf: 'Энэ хүсэлтийг та өөрөө илгээсэн тул шийдвэрлэх боломжгүй.',
          whyNotYourStage: 'Энэ шатны батлах эрх танд байхгүй.',
          whyPastPayrollReach: 'Одоо гаргасан шийдвэр нээлттэй цалингийн тооцоонд нөлөөлөхгүй.',
          whyUnavailable: 'Энэ мөрөнд одоогоор шийдвэр гаргах боломжгүй.',
        },
        scope: 'Хамрах хүрээ', scope_own: 'Өөрийн', scope_team: 'Багийн', scope_all: 'Бүгд',
        scope_own_short: 'Өөрийн', scope_team_short: 'Багийн', scope_all_short: 'Бүгд',
        filterLast60: 'Сүүлийн 60 хоног: {{n}}',
        scope_awaiting: 'Харьяа ажилтан', scope_awaiting_short: 'Харьяа',
        scope_admin: 'Бүгд', scope_admin_short: 'Бүгд',
        scope_backlog: 'Хоцрогдол', scope_backlog_short: 'Хоцрогдол',
        prev: 'Өмнөх', next: 'Дараах', today: 'Өнөөдөр',
        pay: {
          // Энэ мөр доорх тайлбартай андуурагдахгүй байх гарчиг.
          heading: 'Цалин',
          cutOff: 'Тасалбар', payDate: 'Цалин олгох',
        },
        saved: 'Хадгалагдлаа',
        loadFailed: 'Энэ өдрийг ачаалж чадсангүй. Одоохондоо хадгалахад аюулгүй биш байна.',
        retry: 'Дахин оролдох',
        peopleLoadFailed: 'Ажилтны жагсаалтыг ачаалж чадсангүй.',
        noEmployeeRecord: 'Таны нэвтрэх эрх ажилтны бүртгэлтэй холбогдоогүй байна. Хүний нөөцөд хандаж холбуулна уу.',
        day: 'Өдөр', mode: 'Ажлын хэлбэр', activity: 'Үйл ажиллагаа', total: 'Нийт',
        market: 'Аж ахуйн нэгж', product: 'Төсөл', hours: 'Цаг', comment: 'Тайлбар',
        // Market and product are the log line's Entity and Project dropdowns.
        allProducts: 'Бүх бүтээгдэхүүн, үйлчилгээ',
        shift: 'Ээлж', shiftDay: 'Өдөр', shiftNight: 'Шөнө',
        field: {
          overtime_hours: 'Илүү цаг', nighttime_hours: 'Шөнийн',
          over_night_hours: 'Шөнө + ИЦ', transit_hours: 'Замд',
        },
        dayTotal: 'Өдрийн нийт', addLine: 'Мөр нэмэх', removeLine: 'Мөр устгах',
        noLines: 'Энэ өдөрт бүртгэл алга.',
        downtimeHint: 'Сул зогсолттой өдөр {{max_downtime_hours}} цагаар хязгаарлагдах ба илүү цаг тооцогдохгүй.',
        downtimeHintCapped: 'Сул зогсолттой өдөр илүү цаг, шөнийн цаг тооцогдохгүй. Цалинд сул зогсолтыг төслийн ердийн ээлжийн цаг хүртэл тооцно.',
        showExtraHours: 'Илүү цаг нэмэх',
        dow: { 0: 'Ня', 1: 'Да', 2: 'Мя', 3: 'Лх', 4: 'Пү', 5: 'Ба', 6: 'Бя' },
        month: { 0: '1-р сар', 1: '2-р сар', 2: '3-р сар', 3: '4-р сар', 4: '5-р сар', 5: '6-р сар', 6: '7-р сар', 7: '8-р сар', 8: '9-р сар', 9: '10-р сар', 10: '11-р сар', 11: '12-р сар' },
        status: {
          Draft: 'Ноорог', Pending: 'Хүлээгдэж буй', Approved: 'Батлагдсан', Rejected: 'Татгалзсан',
          'Cancel Pending': 'Цуцлах хүсэлт', Cancelled: 'Цуцалсан',
          'Cancel Approved': 'Цуцлалт батлагдсан', 'Cancel Rejected': 'Цуцлалт татгалзсан',
        },
        statusHeading: 'Төлөв', kind: 'Бүртгэлийн төрөл', kindPlan: 'Төлөвлөгөө', kindActual: 'Гүйцэтгэл',
        // Where each mark sits in a day cell.
        backToCalendar: 'Календарь', fillIn: 'Бөглөх',
        legendKey: 'Тайлбар', factoredHours: 'Жигнэсэн цаг', hoursOne: '{{hours}}ц', hoursBoth: 'мэдүүлсэн {{reported}}ц, жигнэсэн {{factored}}ц', legendFactoredDiffers: 'жигнэсэн болон мэдүүлсэн цаг зөрүүтэй', legendActualWhere: 'нүдний гол тоо', legendPlanWhere: 'буланд тасархай шошго',
        hoursTotal: 'Нийт {{hours}} цаг',
        copyPlan: 'Төлөвлөгөөг хуулах', copyActual: 'Гүйцэтгэлийг хуулах', removeLogs: 'Цэвэрлэх',
        submit: 'Илгээх', resubmit: 'Дахин илгээх',
        // Татгалзах товчны хажуугийн шалтгааны талбар.
        rejectReason: 'Татгалзах шалтгаан',
        rejectReasonHint: 'Юуг засах ёстойг бичнэ үү',
        rejectApproved: 'Татгалзах…',
        rejectApprovedSend: 'Өдрийг татгалзах',
        remotePlanNotApproved:
          'Батлагдсан алсын төлөвлөгөө байхгүй — таны удирдагч батлахдаа үүнийг харна.',
        noApprovedPlan: 'Батлагдсан төлөвлөгөөгүй',
        noApprovedPlanHint: 'Энэ өдрийг алсын буюу гэрийн ажлаар бүртгэсэн ч ард нь батлагдсан алсын төлөвлөгөө байхгүй.',
        draft: 'Ноорог',
        copiedPlan: 'Хуулав', cleared: 'Өдрийн бүртгэлийг цэвэрлэв',
        erased: 'Өдрийг устгав',
        savedPendingToDraft: 'Ноорог болгон хадгаллаа. Дахин илгээх хүртэл зөвшөөрлийн дараалалд байхгүй.',
        pastPendingNote: 'Энэ өдөр цалингийн хаалтаас хойш байна. Хадгалсан эсвэл илгээсэн өдрийг цагийн админ батална.',
        savedForTimeAdmin: 'Хадгаллаа. Цалингийн хаалтаас хойш тул цагийн админ батлахыг хүлээж байна.',
        confirmResubmit:
          'Энэ өдөр батлагдсан байна. Хадгалбал батлагдсан төлөв цуцлагдаж, дахин батлуулах шаардлагатай болно. Үргэлжлүүлэх үү?',
        confirmReapproval:
          'Энэ өдөр аль хэдийн батлагдсан байна. Дахин илгээвэл хүлээгдэж буй төлөвт буцаж, батлагч дахин батлах шаардлагатай. Батлагдах хүртэл цалинд тооцогдохгүй. Үргэлжлүүлэх үү?',
        confirmErase:
          'Энэ өдрийг бүрмөсөн устгах уу? Ажлын горим болон бүх бүртгэл нь устах бөгөөд буцаах боломжгүй.',
        editedPending: 'Бүртгэл амжилттай засагдлаа',
        submitted: 'Илгээлээ', approved: 'Батлагдлаа', rejected: 'Татгалзлаа',
        planPick: 'Хуанли дээр өдрүүд дээр дарж төлөвлөгөөнд нэмнэ үү.',
        // Сонгосон өдрүүд календарь дээр тэмдэглэгдэнэ.
        planSelectedOnCalendar: 'Хуанли дээр {{count}} өдөр тэмдэглэгдсэн',
        planClear: 'Сонголтыг арилгах',
        planSubmitted: '{{count}} өдрийн төлөвлөгөөг илгээлээ',
        planAppliesTo: 'Энэ бүртгэл {{count}} өдөрт нэгэн адил хэрэглэгдэнэ: {{dates}}',
        batchApproved: '{{count}} өдрийг батлав',
        batchPartial: '{{done}} өдөр батлагдаж, {{failed}} өдөр батлагдсангүй',
        approveNothingLeft: 'Сонгосон өдрүүд аль хэдийн шийдэгдсэн байна.',
        referencePlan: 'Төлөвлөгөө (зөвхөн харах)',
        findPerson: 'Ажилтан хайх', noSupervisees: 'Танд харьяа ажилтан алга', coveringFor: '{{name}}-г орлож байна', coveringUntil: '{{date}} хүртэл', noPeople: 'Ажилтан олдсонгүй',
        nothingAwaiting: 'Таны шийдвэрийг хүлээж буй зүйл алга',
        awaitingMarker: '{{days}} ө · {{hours}} ц',
        awaitingCurrentMarkerTitle: 'Энэ цалингийн үеийн хүлээгдэж буй {{days}} өдөр, нийт {{hours}} цаг',
        awaitingPastMarker: '{{days}} ө',
        awaitingPastMarkerTitle: 'Өнгөрсөн цалингийн үеэс хүлээгдэж буй {{days}} өдөр',
        noHourlySupervisees:
          'Харуулах харьяа ажилтан алга. Цагаар цалинждаг ажилтан үргэлж харагдана; тогтмол цалинтай ажилтан шийдвэр хүлээж буй өдөртэй үедээ харагдана.',
        noHourlyPeople:
          'Ажилтан олдсонгүй. Энэ жагсаалт цагаар цалинждаг ажилтныг, мөн шийдвэр хүлээж буй өдөртэй тогтмол цалинтай ажилтныг харуулна.',
        nothingToApprove: 'Энэ өдөрт батлах зүйл алга.',
        bulkApproveTitle: 'Батлах хүлээгдэж буй өдрүүд',
        bulkApproveAll: 'Бүгдийг сонгох',
        bulkApproveClear: 'Сонголтыг арилгах',
        bulkApproveAction: 'Сонгосныг батлах ({{count}})',
        bulkApproveDone: '{{count}} өдөр батлагдлаа',
        bulkApproveRefusedTitle: 'Батлагдаагүй өдрүүд',
        bulkApproveRefusedLine: '{{day}}: {{detail}}',
        // The owner sees why a day was sent back.
        sentBack: {
          title: 'Танд буцаагдсан өдрүүд',
          hint: 'Өдрийг дарж нээвэл дараа нь юу хийж болохыг харна.',
          reason: 'Шалтгаан:',
          line: '{{day}} ({{kind}}): {{reason}}',
          cell: 'Шалтгаан: {{reason}}',
          canResubmit: 'энэ өдрийг засаад дахин илгээж болно',
        },
        // The one approve/reject bar at the bottom of the page.
        approvalBar: {
          hintPlan: 'Хүлээгдэж буй төлөвлөгөөний өдрүүд хуанли дээр урьдчилан чагтлагдсан. Шийдэхгүй өдрөө чагтыг авна уу; Батлах, Татгалзах нь зөвхөн чагталсан өдрүүдэд үйлчилнэ.',
          hintActual: 'Шийдэх гүйцэтгэлийн өдрүүдээ хуанли дээр чагтална уу; аль нь ч урьдчилан чагтлагдаагүй. Батлах, Татгалзах нь зөвхөн чагталсан өдрүүдэд үйлчилнэ.',
          // The approve tick on a calendar cell.
          tickDay: '{{day}}-г шийдэхээр чагтлах',
        },
        blocked: { noLines: 'Эхлээд мөр нэмнэ үү', errors: 'Мөрүүдийн алдааг эхлээд засна уу', clock: 'Цагийн бүртгэл мөрүүдийн нийлбэртэй таарахгүй байна', clockMissing: 'Эхлэх, дуусах цагаа эхлээд оруулна уу', busy: 'Хадгалж байна…', nothingToSave: 'Хадгалах өөрчлөлт алга', noPlanDates: 'Хуанлиас өдөр сонгоно уу' },
        // The supervisor picks days on the calendar.
        pick: {
          reject: 'Сонгосныг татгалзах ({{count}})',
          sharedReason: 'Сонгосон бүх өдрийн татгалзах шалтгаан',
          rejectDone: '{{count}} өдөр татгалзагдлаа',
          rejectRefusedTitle: 'Татгалзагдаагүй өдрүүд',
          whyApprove: 'Батлах: {{reason}}',
          whyReject: 'Татгалзах: {{reason}}',
          enterFor: '{{name}}-д цаг оруулах',
          enterApproved: 'Энэ хүнд хадгалсан цаг шууд батлагдсанаар бүртгэгдэнэ.',
          cell: {
            checking: 'Ачаалж байна, энэ өдрийг одоохондоо сонгох боломжгүй.',
            empty: 'Энэ өдөр юу ч бүртгэгдээгүй тул батлах зүйл алга.',
            notPending: 'Зөвхөн хүлээгдэж буй өдрийг сонгоно.',
            notDecidable: 'Энэ хүлээгдэж буй өдрийг энд шийдвэрлэх боломжгүй.',
          },
          toggle: {
            checking: 'Ачаалж байна.',
            nonePending: 'Энэ табад таны шийдвэрийг хүлээж буй өдөр алга.',
          },
          batch: {
            nonePending: 'Энэ табад таны шийдвэрийг хүлээж буй өдөр алга.',
            noneSelected: 'Эхлээд ядаж нэг хүлээгдэж буй өдрийг чагтална уу.',
            working: 'Шийдвэрийг илгээж байна…',
            unsavedEdit: 'Нээлттэй өдрийн өөрчлөлтөө эхлээд хадгалах эсвэл буцаана уу.',
            reasonRequired: 'Татгалзах шалтгаанаа бичнэ үү; чагталсан өдөр бүрт тухайн хүнд харагдана.',
          },
          save: {
            outsidePeriod: 'Удирдагч зөвхөн одоогийн цалингийн хугацааны өдрийг засна.',
            noChange: 'Одоогоор өөрчлөлт алга.',
            fixErrors: 'Эхлээд мөрүүд дээр харагдаж буй алдааг засна уу.',
            saving: 'Хадгалж байна…',
          },
          enter: {
            checking: 'Ачаалж байна.',
            planNotWritable: 'Шууд удирдлага бусдын бодит цагийг оруулж болно, төлөвлөгөөг нь биш.',
            payDateLocked: 'Өнөөдөр цалингийн өдөр тул энэ өдрийн бодит цаг түгжигдсэн.',
            calendarEnded: 'Цалингийн хуваарь дууссан тул энэ өдрийн бодит цагийг зөвхөн цагийн админ оруулна.',
            future: 'Энэ өдөр хараахан болоогүй байна.',
            beforePeriod: 'Энэ өдөр {{floor}}-ээс өмнө байна; та түүнээс хойших өдөрт л цаг оруулж болно.',
          },
        },
        planClosed: 'Төлөвлөгөөг зөвхөн өнөөдрөөс хойшхи өдөрт оруулна.',
        planNeedsALine: 'Төлөвлөгөөг илгээхийн өмнө дор хаяж нэг мөр бөглөнө үү. Урьдчилан харуулсан мөрийг хадгалаагүй байна.',
        actualClosed: 'Гүйцэтгэлийг сүүлийн 7 хоногт бүртгэнэ. Түүнээс өмнөх засварыг админ хийнэ.',
        // Хоцорсон өдрийг гурван хүн гарын үсэг зурж батална.
        cosign: {
          bannerNeeded: 'Энэ өдөр цалингийн хаалтаас хоцорсон. Үүнийг зөвхөн гурван зөвшөөрлөөр — шууд удирдлага, ГЗ, СЗ — бүртгэнэ.',
          bannerNeededEdit: 'Энэ өдөр цалингийн хаалтаас хоцорсон. Өөр хүний хоцорсон өдөрт хийх засвар нь шууд удирдлага, ГЗ, СЗ-ийн зөвшөөрөлд илгээгдэнэ; таны өөрийн зөвшөөрөл гарын үсэгтэй гэж тооцогдоно.',
          sendEdit: 'Засварыг зөвшөөрөлд илгээх',
          confirmBodyEdit: '{{day}} нь цалингийн хаалтаас хоцорсон. Засвар шууд удирдлага, ГЗ, СЗ-ийн зөвшөөрөлд илгээгдэнэ; таны өөрийн зөвшөөрөл гарын үсэгтэй гэж тооцогдох ба бусад нь дарааллын дураар тус бүр зөвшөөрнө. Нэг татгалзал эцсийнх.',
          requiredEdit: 'Энэ өдөр цалингийн хаалтаас хоцорсон тул засварыг шууд хадгалах боломжгүй — «Засварыг зөвшөөрөлд илгээх» товчийг ашиглана уу.',
          bannerAwaiting: 'Хоцорсон өдөр — гурван зөвшөөрөл хүлээж байна. Шууд удирдлага, ГЗ, СЗ бүгд баталсны дараа л батлагдана.',
          bannerApproved: 'Хоцорсон өдөр — шууд удирдлага, ГЗ, СЗ гурвуулаа баталсан.',
          // The owner reports to the CEO or the CFO, so the CEO and the CFO sign alone.
          bannerNeededTwo: 'Энэ өдөр цалингийн хаалтаас хоцорсон. Таны шууд удирдлага ГЗ эсвэл СЗ тул үүнийг зөвхөн хоёр зөвшөөрлөөр — ГЗ, СЗ — бүртгэнэ.',
          bannerAwaitingTwo: 'Хоцорсон өдөр — хоёр зөвшөөрөл хүлээж байна. ГЗ, СЗ хоёулаа баталсны дараа л батлагдана.',
          bannerApprovedTwo: 'Хоцорсон өдөр — ГЗ, СЗ хоёулаа баталсан.',
          sendTwo: 'Хоёр зөвшөөрөлд илгээх',
          confirmBodyTwo: '{{day}} цалингийн хаалтаас хоцорсон. ГЗ, СЗ тус бүр ямар ч дарааллаар батлах ёстой. Нэг татгалзал эцсийнх.',
          // The owner IS the CEO or the CFO, so the other office signs alone.
          bannerNeededOne: 'Энэ өдөр цалингийн хаалтаас хоцорсон. Та ГЗ эсвэл СЗ тул үүнийг зөвхөн нөгөө удирдлагын (ГЗ эсвэл СЗ) нэг зөвшөөрлөөр бүртгэнэ.',
          bannerAwaitingOne: 'Хоцорсон өдөр — нэг зөвшөөрөл хүлээж байна. Нөгөө удирдлага (ГЗ эсвэл СЗ) баталсны дараа батлагдана.',
          bannerApprovedOne: 'Хоцорсон өдөр — нөгөө удирдлага (ГЗ эсвэл СЗ) баталсан.',
          sendOne: 'Нэг зөвшөөрөлд илгээх',
          confirmBodyOne: '{{day}} цалингийн хаалтаас хоцорсон. Нөгөө удирдлага (ГЗ эсвэл СЗ) батлах ёстой. Татгалзвал эцсийнх.',
          bannerRejected: 'Хоцорсон өдөр — татгалзсан. Энэ шийдвэр эцсийнх тул дахин илгээх боломжгүй.',
          bannerBeyond: 'Энэ өдөр нэг цалингийн мөчлөгөөс илүү хоцорсон тул зөвшөөрөлд илгээх боломжгүй.',
          bannerFinal: 'Энэ өдрийг систем автоматаар татгалзсан бөгөөд энэ нь эцсийнх.',
          bannerPaused: 'Энэ өдөр цалингийн хаалтаас хоцорсон. Хоцорсон өдрийг зөвшөөрөлд илгээх боломжийг түр зогсоосон — хүний нөөцийн ажилтан эсвэл админд хандана уу.',
          bannerPayDate: 'Өнөөдөр цалин олгож байгаа тул энэ өдрийг {{date}} өдрөөс эхлэн зөвшөөрөлд илгээх боломжтой.',
          send: 'Гурван зөвшөөрөлд илгээх',
          confirmTitle: 'Хоцорсон өдрийг зөвшөөрөлд илгээх үү?',
          confirmBody: '{{day}} цалингийн хаалтаас хоцорсон. Шууд удирдлага, ГЗ, СЗ тус бүр ямар ч дарааллаар батлах ёстой. Нэг татгалзал эцсийнх.',
          cancel: 'Болих',
          stage: { supervisor: 'Шууд удирдлага', ceo: 'ГЗ', cfo: 'СЗ' },
          verdict: { Pending: 'хүлээгдэж буй', Approved: 'баталсан', Rejected: 'татгалзсан', Waived: 'шаардлагагүй' },
          queueTitle: 'Таны зөвшөөрөл хүлээж буй хоцорсон өдрүүд ({{count}})',
          refusedTitle: 'Миний татгалзсан хоцорсон өдрүүд ({{count}})',
          refusedHint: 'Та эдгээр өдрийг татгалзсан. Буцаавал таны мөр дахин хүлээгдэж буй болж, бусад зөвшөөрөл хэвээр үлдэнэ.',
          refusedReason: 'Таны шалтгаан: {{reason}}',
          reverse: 'Татгалзлаа буцаах ({{stage}})',
          reverseTitle: 'Татгалзлаа буцаах уу?',
          reverseBody: '{{name}}-ийн {{day}}-ний өдрийн {{stage}} мөрийн татгалзлыг буцаана. Хүсэлт дахин нээгдэж, таны зөвшөөрлийг хүлээнэ.',
          reversed: 'Татгалзлыг буцаалаа — хүсэлт дахин нээгдлээ',
          popupTitle: 'Таны зөвшөөрөл шаардлагатай',
          popupBody: 'Эдгээр өдөр цалингийн хаалтаас хоцорсон. Өдөр бүрийг шаардлагатай бүх зөвшөөрөл ирсний дараа л тооцно — шууд удирдлага, ГЗ, СЗ, эсвэл шууд удирдлага нь ГЗ эсвэл СЗ бол зөвхөн ГЗ, СЗ, ГЗ эсвэл СЗ-ийн өөрийн өдрийг зөвхөн нөгөө удирдлага.',
          approve: 'Батлах',
          reject: 'Татгалзах',
          reasonPlaceholder: 'Шалтгаан (татгалзахад заавал)',
          signAs: '{{stage}}-аар батлах',
          close: 'Хаах',
          review: 'Харах',
          required: 'Энэ өдөр цалингийн хаалтаас хоцорсон — оронд нь гурван зөвшөөрөлд илгээнэ үү.',
          paused: 'Хоцорсон өдрийг одоогоор зөвшөөрөлд илгээх боломжгүй — хүний нөөцийн ажилтан эсвэл админд хандана уу.',
          // The owner dialog's closed-month sentence, and the generic 409 text.
          closedMonthNote: '{{month}} сар хаагдсан; энэ өдрийг батлах, цалинд олгох эсэхийг баталсны дараа сервер шийдэнэ.',
          monthClosed: '{{month}} цалингийн сар хаагдсан тул энэ өдрийг одоогоор батлах боломжгүй.',
        },
        actualClosedFloor: 'Энэ өдөр хаагдсан цалингийн мөчлөгт хамаарна ({{floor}}-с өмнөх). Засварыг админ хийнэ.',
        actualClosedMonth: 'Энэ өдөр {{month}} цалингийн сард ({{start}} – {{end}}) хамаарах бөгөөд тэр сар хаагдсан. Засварыг админ хийнэ.',
        actualClosedPayDate: 'Өнөөдөр ({{day}}) цалин олгох өдөр тул {{through}} болон түүнээс өмнөх өдрүүдийн бодит бүртгэлийг өөрчлөх, устгах, батлах боломжгүй. Дараагийн өдрүүд ердийн журмаар нээлттэй. Зөвхөн цагийн админ өөрчилнө.',
        actualClosedCalendarEnded: 'Цалингийн хуваарь {{date}}-нд дууссан тул үүнийг зөвхөн цагийн админ өөрчилнө. Хуанли хариуцагч дараагийн оныг баталгаажуулна.',
        backdateClosedPeriodWarning:
          'Энэ өдөр аль хэдийн хаагдаж, цалин нь олгогдсон мөчлөгт хамаарна ({{floor}}-с өмнөх). Зөвхөн хадгалахыг хүлээн авахгүй: «Засварыг зөвшөөрөлд илгээх» товчийг дарж өөрчлөлтийг хамтарсан зөвшөөрөлд илгээнэ үү.',
        confirmBackdateClosedPeriod:
          'Энэ өдөр аль хэдийн хаагдаж, цалин нь олгогдсон мөчлөгт хамаарна ({{floor}}-с өмнөх). Зөвхөн хадгалахыг хүлээн авахгүй, өөрчлөлт бичигдэхгүй. Өөрчлөлтийг «Засварыг зөвшөөрөлд илгээх» товчоор илгээнэ. Үргэлжлүүлэх үү?',
        decidedBy: 'Сүүлд өөрчилсөн: {{name}}', decidedBeforeTracking: 'Бүртгэл эхлэхээс өмнө шийдвэрлэсэн', decidedAutomatically: 'Автоматаар шийдвэрлэсэн',
        errIncomplete: 'Мөр бүрт зах зээл, үйл ажиллагаа, бүтээгдэхүүн сонгогдсон байх ёстой.',
        errDuplicate: 'Хоёр мөрийн зах зээл, үйл ажиллагаа, бүтээгдэхүүн/үйлчилгээ, ээлж, ажлын хэлбэр ижил байна. Нэгтгэх эсвэл өөрчилнө үү.',
        modeMixed: 'Холимог',
        modeMixedHint: 'Энэ өдрийн бүх мөр өдрийн ажлын хэлбэрээр бүртгэгдээгүй. Та нэгийг сонгох хүртэл мөр бүр өөрийн хэлбэрээ хадгална.',
        errEmptyRow: 'Цаггүй хоосон мөр байна.',
        errNegative: 'Цаг сөрөг байж болохгүй.',
        errDayTotalLong: 'Нэг өдөрт нийт {{max_day_hours}} цагаас хэтэрч болохгүй.',
        errLimitsLoading: 'Цагийн хязгаар ачаалж байгаа тул энэ өдрийг одоогоор хадгалах боломжгүй.',
        errDayTotalShort: 'Замын цаг {{long_transit_over_hours}} цагаас дээш биш бол нэг өдөрт нийт {{max_short_transit_day_hours}} цагаас хэтэрч болохгүй.',
        errOrdinaryHours: 'Үндсэн цаг өдөрт {{max_normal_hours}} цагаас хэтэрч болохгүй.',
        errTransitHours: 'Замын цаг өдөрт {{max_transit_hours}} цагаас хэтэрч болохгүй.',
        errNightHours: 'Шөнийн цаг (22:00–06:00) {{max_night_hours}} цагаас хэтэрч болохгүй.',
        errOvertimeHours: 'Илүү цаг {{max_overtime_hours}} цагаас хэтэрч болохгүй.',
        errDowntime: 'Сул зогсолттой өдөр {{max_downtime_hours}} цагаар хязгаарлагдах ба илүү цаг тооцогдохгүй.',
        errDowntimeNoExtra: 'Сул зогсолттой өдөр илүү цаг, шөнийн цаг, илүү+шөнийн цаг бичих боломжгүй.',
        errDowntimeProjectOnly: 'Сул зогсолтыг зөвхөн Төсөл төрлийн бүтээгдэхүүн/үйлчилгээн дээр бичнэ.',
        // The day's clock and the gate that pins it to the lines.
        clock: {
          title: 'Ажилласан цаг',
          start: 'Эхэлсэн', end: 'Дууссан', gap: 'Завсарлага', extra: 'Нэмэлт',
          startHour: 'Эхлэх цаг', startMinute: 'Эхлэх минут', endHour: 'Дуусах цаг', endMinute: 'Дуусах минут',
          shiftLength: 'Ирц', logged: 'Бүртгэл',
          agrees: 'Тэнцсэн',
          required: 'Энэ өдөр {{logged}} цаг бүртгэсэн тул эхлэх, дуусах цагаа оруулна уу.',
          none: 'Энэ өдөр цагийн бүртгэлгүй.',
          remove: 'Цагийн бүртгэлийг устгах',
          mismatch: 'Мөрүүдийн нийлбэр {{logged}} цаг боловч ээлж {{shift}} цаг байна. Илгээхийн тулд тэнцүү байх ёстой.',
        },
      },
      leave: {
        remaining: {
          title: 'Үлдсэн чөлөө',
          help: 'Үлдэгдлээс шийдвэр хүлээж буй бүх хүсэлтийг хассан дүн; хүлээгдэж буй энэ хүсэлт ч орсон.',
          pending: '{{days}} хүлээгдэж буй',
          takenSl: 'Авсан SL',
          loadFailed: 'Үлдсэн чөлөөг ачаалж чадсангүй.',
        },
        filters: 'Шүүлтүүр',
        calendarTitle: 'Хэн чөлөөтэй байна',
        nobodyAway: 'Энэ сард чөлөө авсан хүн алга.',
        blockRefused: '10-р сараас хойш {{type}} чөлөө авахын тулд заавал {{days}} ажлын өдрийн ээлжийн амралтын блокийг биелүүлсэн байх ёстой. Нэг удаагийн зөвшөөрлийг зөвхөн чөлөөний админ олгох боломжтой.',
        newRequest: 'Шинэ хүсэлт', type: 'Чөлөөний төрөл', from: 'Эхлэх', to: 'Дуусах',
        // PSL is one day per request (0.5 or 1).
        oneDayOnly: 'Цалинтай өвчний чөлөө нэг хүсэлтээр нэг өдөр л байна — хагас эсвэл бүтэн өдөр.',
        halfDay: 'Хагас өдөр', reason: 'Шалтгаан', requestedDays: 'Хүссэн хоног',
        pendingDays: 'Хүлээгдэж буй хүсэлт',
        afterRequest: 'Үлдэгдэл', overBalance: 'Үлдэгдлээс хэтэрсэн байна.',
        peerOverlap: 'Хамт олон ({{names}}) мөн энэ хугацаанд чөлөөтэй байна. Нийт {{count}} хүсэлт давхцаж байна.',
        peerOverlapCount: 'Энэ хугацаанд хамт олны {{count}} хүсэлт давхцаж байна.',
        selfOverlapCount: 'Та эдгээр өдрүүдэд аль хэдийн {{count}} хүсэлт гаргасан байна.',
        appointedPeerClash: 'Таны HR хамтрагч {{name}} энэ хугацаанд ({{from}} – {{to}}) чөлөө авсан байна. Хоёулаа нэг дор чөлөө авах боломжгүй тул хэн нэг нь огноогоо өөрчлөх шаардлагатай.',
        ledgerAutosave: 'Талбар бүр фокусаас гарахад автоматаар хадгалагдана.',
        attachmentHint: 'Эмнэлгийн магадлагаа зэрэг баримтыг хүсэлт үүсгэсний дараа хавсаргана.',
        submit: 'Хүсэлт илгээх',
        reasonMissing: 'Чөлөөний шалтгаанаа бичнэ үү', rangeInvalid: 'Дуусах огноо эхлэх огнооноос өмнө байна', submitting: 'Хүсэлтийг илгээж байна…', saving: 'Хадгалж байна…', nothingToSave: 'Хадгалах өөрчлөлт алга',
        dates: 'Хугацаа', requestedOn: 'Хүсэлт гаргасан', attachments: 'Хавсралт',
        approvals: 'Зөвшөөрөл', youSign: '(та)',
        stage: { supervisor: 'Шууд удирдлага', management: 'ГЗ', finance: 'СЗ' },
        stageNotReached: 'Хараахан хүрээгүй',
        finalRule: 'Удирдлага баталсны дараа санхүү эсвэл шууд удирдлагын аль нэг нь баталвал хүсэлт эцэслэн батлагдана.',
        trail: { title: 'Түүх', empty: 'Шийдвэр одоогоор бүртгэгдээгүй байна.', error: 'Түүхийг ачаалж чадсангүй.' },
        comment: 'Тайлбар', rejectionHint: 'Татгалзсан бол шалтгаанаа бичнэ үү.',
        rejectedBy: 'Татгалзсан:', reasonRequired: 'Татгалзахын тулд шалтгаанаа бичнэ үү.',
        withdraw: 'Буцаан татах', requestCancel: 'Цуцлах хүсэлт гаргах', stopCancel: 'Цуцлахаа болих',
        resubmit: 'Дахин илгээх', approve: 'Батлах', reject: 'Татгалзах',
        approveCancel: 'Цуцлахыг зөвшөөрөх', rejectCancel: 'Цуцлахыг татгалзах',
        days: 'Хоног', status: 'Төлөв', allStatuses: 'Бүх төлөв', allTypes: 'Бүх төрөл',
        awaiting: 'Шийдвэр хүлээж буй',
        none: 'Хүсэлт алга',
        noneUnderFilter: 'Энэ шүүлтүүрт тохирох хүсэлт алга.',
        noLeave: 'Чөлөөний хүсэлт алга', noLeaveUnderFilter: 'Энэ шүүлтүүрт тохирох чөлөөний хүсэлт алга.', showAll: 'Бүгдийг харуулах ({{count}})',
        overridesLoadFailed: 'Тусгай зөвшөөрлүүдийг ачаалж чадсангүй:',
        balAl: 'Ээлжийн амралт', balCl: 'Энгийн чөлөө', balPsl: 'Цалинтай өвчний', balSpl: 'Сургуулийн цагдаагийн чөлөө',
        balSl: 'Авсан өвчний', balTakenSl: 'Авсан өвчний', balRl: 'Ашиглах боломжтой RL',
        balanceDays: 'Чөлөөний үлдэгдэл (хоног)',
        rlUnavailable: 'хуримтлагдсан хоног алга байна',
        ledgerHint: 'Чөлөөний үлдэгдэл ажилтны бүртгэл дээр биш энд байрлана: батлагдсан хүсэлт үлдэгдлийг өөрөө хасах бөгөөд залруулга, шилжүүлэг, өмнөх ажилласан хугацааны тооцоог эндээс оруулна.',
        balancesSaved: 'Үлдэгдэл хадгалагдлаа',
        created: 'Хүсэлт илгээгдлээ', cancelRequested: 'Цуцлах хүсэлт илгээгдлээ',
        cancelStopped: 'Цуцлах хүсэлтийг болилоо', resubmitted: 'Дахин илгээлээ', withdrawn: 'Хүсэлтийг буцаалаа',
        decidedStage: 'Таны зөвшөөрөл бүртгэгдлээ', decidedFinal: 'Хүсэлтийн эцсийн төлөв: {{status}}',
        teamBalances: 'Багийн чөлөөний үлдэгдэл',
        handoverForm: 'Таныг эзгүй байх хугацаанд {{name}} дараах эрхтэй байна: {{rights}}.',
        handoverApprove: 'Зөвшөөрвөл чөлөө дуустал {{name}} дараах эрхтэй болно: {{rights}}.',
        handoverRefused: '{{name}} үндсэн ажилтан биш тул энэ чөлөөний хугацаанд түүнд эрх шилжихгүй.',
        handoverLoadFailed: 'Энэ чөлөөгөөр ямар эрх шилжихийг ачаалж чадсангүй.',
        handoverRoster: 'Ээлжийн менежер',
        standIn: 'Орлох хүн', standInDefault: 'Анхны утга (HR хамтрагч)',
        standInDefaultNamed: 'Анхны утга (HR хамтрагч: {{name}})',
        standInDefaultNone: 'Тохирох хамтрагч алга байна',
        onBehalfOf: '{{name}}-г орлож байна',
        onLeaveToday: 'Өнөөдөр чөлөөтэй',
        onLeaveNone: 'Өнөөдөр хэн ч чөлөө аваагүй.',
        specialPermission: 'Тусгай чөлөөний зөвшөөрөл',
        specialPermissionHint: '10 хоногийн заавал авах ээлжийн амралтаа аваагүй байхад 10 дугаар сараас хойш ЦӨЧ, энгийн чөлөө авах нэг удаагийн зөвшөөрөл.',
        grantSpecialPermission: 'Зөвшөөрөл олгох',
        specialPermissionGranted: 'Зөвшөөрөл олголоо',
        specialPermissionNone: 'Одоогоор зөвшөөрөл олгоогүй байна.',
        specialPermissionHistory: 'Түүх',
        stats: 'Тоо баримт',
        statsScope: '{{count}} хүний дүн',
        statsPartial: 'Зөвхөн таны харах эрхтэй хүмүүсийн дүн.',
        topAl: 'Ээлжийн амралт хамгийн ихтэй 5',
        fullTimeOnly: 'Зөвхөн бүтэн цагийн',
        showNonFullTime: 'Бүтэн бус цагийнхныг харуулах',
        peopleAndNumbers: 'Хүмүүс ба үлдэгдэл',
        typeTotals: '{{year}} онд авсан чөлөө',
      },
      timeadmin: {
        revert: 'Буцаах', logsSaved: '{{name}}-ийн бүртгэл хадгалагдлаа',
        leaveHint: 'Чөлөөний бичилтийг шууд засна — огноо, төрөл, төлөв. Хүсэлт батлах ажил нь чөлөөний хуудсан дээр байдаг.',
        requestsOf: 'Чөлөөний хүсэлтүүд ({{count}})',
        overrideTitle: 'Чөлөөний дүрмийг давах',
        overrideHint: 'Админ энэ дүрмийг шалтгаантайгаар давж болно. Давсан үйлдэл таны шалтгааны хамт аудитын бүртгэлд хадгалагдаж, ажилтан болон (хамааралтай бол) хамтрагч ажилтанд мэдэгдэл очно.',
        overrideReason: 'Давах шалтгаан',
        overrideConfirm: 'Дүрмийг давж хадгалах',
        sectionLogs: 'Гүйцэтгэлийн бүртгэл',
        balanceUnsaved: 'Хадгалаагүй өөрчлөлт байна.',
        balanceVersioned: 'Засвар бүр шинэ огноотой бичлэг үүсгэнэ — өмнөх үлдэгдэл болон хэн өөрчилсөн нь хэвээр үлдэнэ.',
        balanceGuide: 'Үлдэгдэл засварлах заавар',
        balanceGuideOpen: 'Заавар нээх',
        guideEditing: 'Юуг засах вэ',
        guideVersioning: 'Засвар бүр огноотой',
        guideLedger: 'Үлдэгдэл хаана байрладаг вэ',
        balanceNotANumber: 'Үлдэгдэл нь сөрөг биш тоо байх ёстой.',
        noBalanceRow: 'Энэ ажилтанд чөлөөний эрхийн бүртгэл алга.',
        newProduct: 'Шинэ бүтээгдэхүүн, үйлчилгээ',
        descriptionEn: 'Тайлбар (EN)', descriptionMn: 'Тайлбар (МН)',
        activities: 'Үйл ажиллагаа', products: 'Бүтээгдэхүүн, үйлчилгээ',
        activitiesHint: 'Ямар төрлийн ажил байсныг заана. Бүртгэлийн мөр бүр нэгийг сонгоно.', activityCount: 'Нийт: {{count}}', descriptions: 'Тайлбар', loadActivitiesFailed: 'Ажлын төрлүүдийг ачаалж чадсангүй', noActivities: 'Ажлын төрөл алга. Дээрээс эхнийхийг нэмнэ үү.', nameRequired: 'Нэр оруулна уу', pickTargetRequired: 'Бүртгэлийн мөрүүдийг аль төрөл рүү шилжүүлэхийг сонгоно уу', loadProductsFailed: 'Бүтээгдэхүүн, үйлчилгээг ачаалж чадсангүй', noProducts: 'Бүтээгдэхүүн, үйлчилгээ алга. Дээрээс эхнийхийг нэмнэ үү.', loadUsageFailed: 'Хэрэглээг тоолж чадсангүй', loadPeopleFailed: 'Хүмүүсийн жагсаалтыг ачаалж чадсангүй', moveTargetRequired: 'Аль бүтээгдэхүүн рүү шилжүүлэхийг сонгоно уу', moveBlocked: 'Сервер энэ шилжүүлгийг татгалзана: дээрх тайлбарыг үзнэ үү', moveNoPreview: 'Тоо ачаалагдсангүй: бүтээгдэхүүнээ дахин сонгоно уу', loadCalendarFailed: 'Амралтын өдрүүдийг ачаалж чадсангүй', loadCutOffsFailed: 'Цалингийн хаалтын өдрүүдийг ачаалж чадсангүй', holidaysTitle: '{{year}} оны амралтын өдрүүд', holidayDate: 'Огноо', holidayKind: 'Төрөл', holidayDayOutsideYear: '{{year}} оны өдөр сонгоно уу',
        productsHint: 'Ажил юунд зориулагдсаныг заана. Бүтэц зохион байгуулалттай нэг жагсаалтыг хуваалцана.',
        newActivity: 'Шинэ бүртгэл', addActivity: 'Нэмэх', activity: 'Нэр', typeOf: 'Ангилал',
        active: 'Идэвхтэй', inUse: 'Ашиглаж байна', retired: 'Хаагдсан', activityAdded: 'Нэмэгдлээ',
        earnsTransit: 'Унааны нэмэгдэл',
        deleteActivity: 'Устгах',
        activityRuleBound: 'Энэ бичилт бүртгэлийн дүрэмтэй тул устгах боломжгүй. Оронд нь хаана уу.',
        deleteActivityHint: '‘{{activity}}’-г устгавал үүнийг ашигласан бүх мөр өөр бичилт рүү шилжинэ. Буцаах боломжгүй.',
        moveLinesTo: 'Мөрүүдийг шилжүүлэх', pickTarget: 'Бичилт сонгоно уу…',
        mergeNothing: 'Энэ бичилтийг ашигласан мөр алга — зүгээр л устана.',
        mergeSummary: '{{days}} өдрийн {{lines}} мөр ‘{{target}}’ болно.',
        mergeFolded: 'Үүнээс {{count}} нь тухайн өдөр давхцаж байгаа тул нэгтгэгдэнэ — цаг хэвээрээ, мөр нь нийлнэ.',
        confirmDeleteActivity: 'Устгаад шилжүүлэх',
        activityDeleted: '‘{{activity}}’ устлаа · {{count}} мөр ‘{{target}}’ руу шилжлээ',
        impactTitleAdded: '{{day}}-ны баярын өдөр чөлөөний дотор таарч байна',
        impactTitleRemoved: '{{day}}-ны баярын өдрийг хасвал чөлөөнд нөлөөлнө',
        impactIntro: 'Чөлөө тус бүрийг юу болгохоо сонгоно уу. Бүгдийг сонгох хүртэл юу ч хадгалагдахгүй, хүн бүрт мэдэгдэнэ.',
        impactLeaveSpan_one: '{{start}} - {{end}}, {{count}} өдөр',
        impactLeaveSpan_other: '{{start}} - {{end}}, {{count}} өдөр',
        impactChoiceFor: '{{name}}-н сонголт',
        impactExtend_one: 'Сунгах: {{end}}-нд дуусна, {{count}} өдөр хэвээр',
        impactExtend_other: 'Сунгах: {{end}}-нд дуусна, {{count}} өдөр хэвээр',
        impactMove: '{{day}} руу шилжүүлэх',
        impactGiveBack_one: 'Өдрийг буцаах: огноо хэвээр, {{count}} өдөр',
        impactGiveBack_other: 'Өдрийг буцаах: огноо хэвээр, {{count}} өдөр',
        impactGiveBackCancels: 'Өдрийг буцаах: энэ чөлөө цуцлагдана',
        impactShorten_one: 'Богиносгох: {{end}}-нд дуусна, {{count}} өдөр хэвээр',
        impactShorten_other: 'Богиносгох: {{end}}-нд дуусна, {{count}} өдөр хэвээр',
        impactCharge_one: 'Нэг өдөр нэмж тооцох: огноо хэвээр, {{count}} өдөр',
        impactCharge_other: 'Нэг өдөр нэмж тооцох: огноо хэвээр, {{count}} өдөр',
        impactStuck: 'Аль ч сонголт боломжгүй. Чөлөөний админ энэ чөлөөний огноог өөрчлөх эсвэл цуцлах ёстой; дараа нь энэ баярын өдрийг дахин хадгална уу.',
        impactSave: 'Баярын өдрийг хадгалах',
        impactRefusedOverlap: 'Өөр чөлөөтэй давхцана.',
        impactRefusedClosedMonth: 'Хаагдсан цалингийн сард орно.',
        impactRefusedPeriodRun: 'Цалин нь бодогдсон үед орно.',
        impactRefusedYearUnconfirmed: 'Календарь нь баталгаажаагүй онд орно.',
        impactRefusedOneDayOnly: 'Энэ төрлийн чөлөө зөвхөн нэг өдөр байна.',
        impactRefusedOverdraw: 'Үлдэгдлээс хэтэрнэ.',
        impactRefusedResetPaid: 'Оны эцсийн тооцооллын дүнг 1-р сарын цалингаар аль хэдийн олгосон.',
        impactRefusedNoWorkingDay: 'Энэ чөлөөнд богиносгох ажлын өдөр алга.',
        impactRefusedDaysDiffer: 'Хадгалсан өдрийн тоо огноотой таарахгүй байна, эхлээд чөлөөг засна уу.',
        impactRefusedMustTake: 'Энэ бол цорын ганц 10 өдрийн ээлжийн амралт бөгөөд энэ онд дахин 10 өдөр авах боломж алга.',
        confirmedAdminOnly: '{{year}} он баталгаажсан тул баярын өдрийг нь зөвхөн админ өөрчилнө.', confirmYear: '{{year}} оныг баталгаажуулах', yearConfirmed: 'Баталгаажсан', yearUnconfirmed: '{{year}} он баталгаажаагүй',
        copyYear: '{{year}} оны баярыг хуулах', copiedCheckDate: '{{year}} оны огноотой ижил — шалгана уу', copiedMark: 'Огноог шалгах',
        copyYearDone: '{{year}} оноос {{count}} баяр хуулсан. Огноог шалгаад баталгаажуулна уу.', copyYearSkipped: 'Алгассан: {{days}}',
        nationalHoliday: 'Улсын баяр', companyHoliday: 'Компанийн амралт', weekend: 'Амралтын өдөр',
        holidaysOf: 'Баярын өдрүүд · {{year}} {{month}}', noHolidays: 'Энэ сард баяр алга.',
        holidayName: 'Баярын нэр', removeHoliday: 'Баярыг устгах',
        yearNotImported: '{{year}} оны хуанли оруулаагүй байна — амралтын өдөр хэвээр, баярыг гараар нэмнэ.',
        calendarSaved: 'Хуанли хадгалагдлаа', calendarReset: 'Хуанлийг анхны жагсаалтад буцаалаа',
        summaryNational: '{{year}} оны улсын баяр', summaryCompany: '{{year}} оны компанийн амралт',
        summaryWorkdays: '{{year}} оны ажлын өдөр',
        tabTimeLogging: 'Цагийн бүртгэл', tabLeave: 'Чөлөө',
        statPendingDays: 'Хүлээгдэж буй өдөр', statRejectedDays: 'Татгалзсан өдөр',
        statPendingRequests: 'Хүлээгдэж буй хүсэлт',
        cutOffDay: 'Цалингийн тасалбар өдөр', cutOffMark: 'Тасалбар',
        cutOffsNearby: 'Цалингийн тасалбар өдрүүд', holidaysNearby: 'Баярын өдрүүд',
        listPrevious: 'Өмнөх', listUpcoming: 'Дараах',
        noCutOffsNearby: 'Энэ сарын орчимд цалингийн хугацаа үүсээгүй байна.',
        noHolidaysNearby: 'Энэ сарын орчимд баяр алга.',
        paysOn: '{{date}}-нд олгоно',
        // A product's uses, moving them, deleting it.
        uses: 'Хэрэглээ',
        usageTitle: '{{product}}-ийн хэрэглээ',
        usageLoading: 'Тоолж байна…',
        useNone: 'Энэ бүтээгдэхүүнийг юу ч ашиглаагүй — устгаж болно.',
        useLines: 'Цагийн бүртгэлийн мөр: {{count}}',
        useRoles: 'Ажилтны бүтээгдэхүүний үүрэг: {{count}}',
        usePlannedDays: 'Төлөвлөсөн ээлжийн өдөр: {{count}}',
        useActualDays: 'Гүйцэтгэсэн ээлжийн өдөр: {{count}}',
        useLogDays: 'Бүртгэсэн ээлжийн өдөр: {{count}}',
        useExternalProjects: 'Төсөл болгон бичсэн гэрээт ажилтны бүртгэл: {{count}}',
        useRosterCells: 'Монгол нэрээр нь хадгалсан ээлжийн нүд: {{count}}',
        usageSpan: '{{people}} хүн бөглөсөн, {{first}} – {{last}}.',
        usageClosedLines: 'Үүнээс {{count}} мөр нь хаагдсан цалингийн сард байна.',
        usageRosterRow: 'Ээлжийн хуваарьт “{{name}}” нэрээр.',
        showPeople: 'Хэн бөглөсөн',
        hidePeople: 'Хүмүүсийг нуух',
        colPerson: 'Ажилтан',
        colDays: 'Өдөр',
        colHours: 'Цаг',
        colSpan: 'Эхний – сүүлийн өдөр',
        moveTitle: 'Эдгээр хэрэглээг өөр бүтээгдэхүүн рүү шилжүүлэх',
        moveHint: 'Бүх мөр, үүрэг, төслийн нэр таны сонгосон бүтээгдэхүүн рүү шилжинэ. Тухайн өдөр ижил мөртэй бол нэгтгэгдэнэ. Эхлээд тоог харахын тулд бүтээгдэхүүн сонгоно уу.',
        moveRefusedAhead: '{{count}} мөр хаагдсан цалингийн сард байгаа бөгөөд сонгосон бүтээгдэхүүн дараах тохиргоогоор ялгаатай: {{settings}}. Шилжүүлбэл хаагдсан цалин өөрчлөгдөх тул шилжүүлэлтийг татгалзана. Ижил тохиргоотой бүтээгдэхүүн сонгох эсвэл үүнийг идэвхгүй болгоно уу.',
        typicalShiftHours: 'Ердийн ээлжийн цаг', pickProduct: 'Бүтээгдэхүүн сонгоно уу…',
        movePreviewLines: '{{lines}} мөр {{target}} рүү шилжинэ; үүнээс {{merged}} нь байгаа мөрт нэгтгэгдэнэ.',
        movePreviewRoles: '{{moved}} үүрэг шилжинэ; {{skipped}} нь тухайн хүн сонгосон бүтээгдэхүүн дээр аль хэдийн үүрэгтэй тул хасагдана.',
        movePreviewCopies: '{{days}} ээлжийн өдөр, {{records}} ажилтны бүртгэлд шинэ төслийн нэр бичигдэнэ.',
        moveRosterMoved: 'Ээлжийн хуваарийн бүртгэл нь сонгосон бүтээгдэхүүн рүү шилжинэ.',
        moveRosterDropped: 'Сонгосон бүтээгдэхүүн өөрийн ээлжийн бүртгэлтэй тул энэ нь хасагдана.',
        confirmMove: 'Шилжүүлэх',
        moved: '{{source}}-ийн бүх хэрэглээг {{target}} рүү шилжүүллээ',
        deleteProductHint: 'Энэ бүтээгдэхүүнийг одоо юу ч ашиглахгүй байна. Устгавал бүрмөсөн арилна.',
        deleteProductBlocked: 'Юу ч ашиглахгүй болсон үед л устгаж болно — дээрх хэрэглээг эхлээд шилжүүлэх, эсвэл Идэвхтэй сонголтоор идэвхгүй болгоно уу.',
        deleteProduct: 'Бүтээгдэхүүн устгах',
        confirmDeleteProduct: 'Бүрмөсөн устгах',
        productDeleted: '{{product}}-ийг устгалаа',
      },
  },
  en: {
      time: {
        // The status view for items that have waited too long.
        backlog: {
          whySelf: 'You submitted this one, so you cannot decide it.',
          whyNotYourStage: 'You do not hold this approval stage.',
          whyPastPayrollReach: 'No decision made now changes any open payroll run.',
          whyUnavailable: 'There is no decision available on this row.',
        },
        scope: 'Scope', scope_own: 'Mine', scope_team: 'My team', scope_all: 'Everyone',
        scope_own_short: 'Mine', scope_team_short: 'Team', scope_all_short: 'All',
        filterLast60: 'Last 60 days: {{n}}',
        scope_awaiting: 'Supervisees', scope_awaiting_short: 'Supervisees',
        scope_admin: 'Everyone', scope_admin_short: 'Everyone',
        scope_backlog: 'Backlog', scope_backlog_short: 'Backlog',
        prev: 'Previous', next: 'Next', today: 'Today',
        // Prefixed to a date in the month grid's footer, so these
        // are labels rather than sentences -- 'Cut-off 6/9', not 'the
        // cut-off date is'. `run.*` is keyed by the server's `run` value and
        // shows only when a month carries both an advance and a final.
        pay: {
          // A heading, so the strip does not read as the Legend's first row.
          heading: 'Salary',
          cutOff: 'Cut-off', payDate: 'Pay',
        },
        saved: 'Saved',
        // `dayEditorState`'s error branch -- distinct from
        // `noLines`, which is a true and expected sentence about a day that
        // loaded and is simply empty.
        loadFailed: 'Could not load this day. Nothing here is safe to save yet.',
        retry: 'Retry',
        // Approve/Reject disabled while the editor is dirty --
        // `decide()` acts on the STORED day, so an unsaved edit on screen
        // would be approved as something other than what it shows.
        peopleLoadFailed: 'The staff list could not be loaded.',
        noEmployeeRecord: 'Your login is not linked to a personnel record. Ask HR to link it.',
        day: 'Day', mode: 'Work mode', activity: 'Activity', total: 'Total',
        market: 'Entity', product: 'Project', hours: 'Hours', comment: 'Comment',
        // Market and product are the log line's Entity and Project dropdowns.
        allProducts: 'All products & services',
        shift: 'Shift', shiftDay: 'Day', shiftNight: 'Night',
        field: {
          overtime_hours: 'Overtime', nighttime_hours: 'Nighttime',
          over_night_hours: 'Night + OT', transit_hours: 'Transit',
        },
        dayTotal: 'Day total', addLine: 'Add line', removeLine: 'Remove line',
        noLines: 'Nothing logged for this day.',
        downtimeHint: 'A downtime day is capped at {{max_downtime_hours}} hours and carries no overtime.',
        downtimeHintCapped: 'A downtime day carries no overtime or night hours. Payroll pays downtime only up to the typical shift of the project.',
        showExtraHours: 'Add overtime & night hours',
        dow: { 0: 'Sun', 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat' },
        month: { 0: 'January', 1: 'February', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' },
        status: {
          Draft: 'Draft', Pending: 'Pending', Approved: 'Approved', Rejected: 'Rejected',
          'Cancel Pending': 'Cancellation pending', Cancelled: 'Cancelled',
          'Cancel Approved': 'Cancellation approved', 'Cancel Rejected': 'Cancellation rejected',
        },
        statusHeading: 'Status', kind: 'Log type', kindPlan: 'Plan', kindActual: 'Actual',
        // Where each mark sits in a day cell.
        backToCalendar: 'Calendar', fillIn: 'Fill in',
        legendKey: 'Key', factoredHours: 'Factored hours', hoursOne: '{{hours}}h', hoursBoth: '{{reported}}h reported, {{factored}}h factored', legendFactoredDiffers: 'factored and reported hours differ', legendActualWhere: 'the main figure in a day', legendPlanWhere: 'dashed corner badge',
        hoursTotal: '{{hours}} h total',
        copyPlan: 'Copy plan', copyActual: 'Copy actual', removeLogs: 'Clear day',
        submit: 'Submit', resubmit: 'Resubmit',
        // Deliberately NOT the `leave.*` twins: same words,
        // different screen, and a shared key would tie a toolbar label to a
        // dialog's wording for good.
        rejectReason: 'Rejection reason',
        rejectReasonHint: 'Say what has to change',
        rejectApproved: 'Reject…',
        rejectApprovedSend: 'Reject day',
        remotePlanNotApproved:
          'No approved remote plan — your supervisor will see this when approving.',
        noApprovedPlan: 'No approved plan',
        noApprovedPlanHint: 'This day was filed as remote or home work with no approved remote plan behind it.',
        draft: 'Draft',
        copiedPlan: 'Copied', cleared: 'Day cleared',
        erased: 'Day erased',
        savedPendingToDraft: 'Saved as a draft. It stays out of the approval queue until you submit it again.',
        pastPendingNote: 'This day is behind the payroll cut-off. Once saved or submitted, a time admin approves it.',
        savedForTimeAdmin: 'Saved. It is behind the payroll cut-off, so it waits for a time admin to approve it.',
        confirmResubmit:
          'This day is already approved. Saving it withdraws that approval and it will need approving again. Continue?',
        confirmReapproval:
          'This day is already approved. Submitting it again sends it back to Pending, and the approver must approve it again. Until then payroll does not count it. Continue?',
        confirmErase:
          'Erase this day completely? Its work mode and every log on it will be removed, and this cannot be undone.',
        editedPending: 'Log edited successfully',
        submitted: 'Submitted for approval', approved: 'Approved', rejected: 'Rejected',
        planPick: 'Click dates on the calendar to add them to the plan.',
        // The picked days are marked in the grid now, so what is
        // left below it is a count and a way out.
        planSelectedOnCalendar: '{{count}} days marked on the calendar',
        planClear: 'Clear selection',
        planSubmitted: 'Submitted the plan for {{count}} days',
        planAppliesTo: 'This log applies to {{count}} days the same way: {{dates}}',
        batchApproved: 'Approved {{count}} days',
        batchPartial: 'Approved {{done}}; {{failed}} not approved',
        approveNothingLeft: 'Those days have already been decided.',
        referencePlan: 'Plan (read-only)',
        findPerson: 'Find a person', noSupervisees: 'Nobody reports to you', coveringFor: 'Covering for {{name}}', coveringUntil: 'until {{date}}', noPeople: 'No people found',
        nothingAwaiting: 'Nothing awaiting your decision',
        awaitingMarker: '{{days}} d · {{hours}} h',
        awaitingCurrentMarkerTitle: '{{days}} day(s) pending in the current payroll period, {{hours}} hours in total',
        awaitingPastMarker: '{{days}} d',
        awaitingPastMarkerTitle: '{{days}} day(s) still pending from past payroll periods',
        noHourlySupervisees:
          'No supervisees to show. Staff paid by the hour are always listed; salaried staff appear while they have a day awaiting a decision.',
        noHourlyPeople:
          'No staff found. This list shows staff paid by the hour, and salaried staff while they have a day awaiting a decision.',
        nothingToApprove: 'Nothing to approve for this day.',
        bulkApproveTitle: 'Days awaiting approval',
        bulkApproveAll: 'Select all',
        bulkApproveClear: 'Clear selection',
        bulkApproveAction: 'Approve selected ({{count}})',
        bulkApproveDone: 'Approved {{count}} days',
        bulkApproveRefusedTitle: 'Not approved',
        bulkApproveRefusedLine: '{{day}}: {{detail}}',
        // The owner sees why a day was sent back.
        sentBack: {
          title: 'Days sent back to you',
          hint: 'Click a day to open it and see what you can do next.',
          reason: 'Reason:',
          line: '{{day}} ({{kind}}): {{reason}}',
          cell: 'Reason: {{reason}}',
          canResubmit: 'you can correct this day and resubmit it',
        },
        // The one approve/reject bar at the bottom of the page.
        approvalBar: {
          hintPlan: 'Pending plan days start ticked on the calendar. Untick any you are not deciding; Approve and Reject act on exactly the ticked days.',
          hintActual: 'Tick the actual days to decide on the calendar; none start ticked. Approve and Reject act on exactly the ticked days.',
          // The approve tick on a calendar cell.
          tickDay: 'Tick {{day}} to decide',
        },
        blocked: { noLines: 'Add a line first', errors: 'Fix the errors in the lines first', clock: 'The clock times do not match the lines', clockMissing: 'Enter the start and end time first', busy: 'Saving…', nothingToSave: 'There is nothing to save', noPlanDates: 'Pick a day on the calendar first' },
        // The supervisor picks days on the calendar.
        pick: {
          reject: 'Reject selected ({{count}})',
          sharedReason: 'Rejection reason for every selected day',
          rejectDone: 'Rejected {{count}} days',
          rejectRefusedTitle: 'Not rejected',
          whyApprove: 'Approve: {{reason}}',
          whyReject: 'Reject: {{reason}}',
          enterFor: 'Enter time for {{name}}',
          enterApproved: 'What you save for this person is recorded as approved straight away.',
          cell: {
            checking: 'Still loading, so this day cannot be selected yet.',
            empty: 'Nothing is filed for this day, so there is nothing to approve.',
            notPending: 'Only pending days can be selected.',
            notDecidable: 'This pending day cannot be decided here.',
          },
          toggle: {
            checking: 'Still loading.',
            nonePending: 'No day on this tab is waiting for your decision.',
          },
          batch: {
            nonePending: 'No day on this tab is waiting for your decision.',
            noneSelected: 'Tick at least one pending day first.',
            working: 'Sending the decision…',
            unsavedEdit: 'Save or revert your change to the open day first.',
            reasonRequired: 'Write a rejection reason; the person sees it on every ticked day.',
          },
          save: {
            outsidePeriod: 'Supervisors can only change days in the current payroll period.',
            noChange: 'Nothing changed yet.',
            fixErrors: 'Fix the problems shown on the lines first.',
            saving: 'Saving…',
          },
          enter: {
            checking: 'Still loading.',
            planNotWritable: "A supervisor can enter someone's actual time, not their plan.",
            payDateLocked: 'Today is a pay date, so actual time for this day is locked.',
            calendarEnded: 'The pay calendar has ended, so only a time admin can enter actual time for this day.',
            future: 'This day has not happened yet.',
            beforePeriod: 'This day is before {{floor}}, the earliest day you can enter time for.',
          },
        },
        planClosed: 'A plan can only be entered for today onwards.',
        planNeedsALine: 'Add at least one line before submitting the plan — the line shown is a prefilled suggestion and has not been saved.',
        actualClosed: 'Actual hours can be logged for the last seven days. Ask an administrator to correct anything older.',
        // A late day co-signed by three people.
        cosign: {
          bannerNeeded: 'This day is behind the payroll cut-off. It can only be logged by sending it for three approvals — your supervisor, the CEO and the CFO.',
          bannerNeededEdit: 'This day is behind the payroll cut-off. A change to someone else’s late day is sent for approval by the supervisor, the CEO and the CFO; your own line counts as signed.',
          sendEdit: 'Send change for approval',
          confirmBodyEdit: '{{day}} is behind the payroll cut-off. The change is sent for approval by the supervisor, the CEO and the CFO; your own line counts as signed and the others must each approve, in any order. One refusal is final.',
          requiredEdit: 'This day is behind the payroll cut-off, so the change cannot be saved directly — use Send change for approval.',
          bannerAwaiting: 'Late day — awaiting three approvals. It is approved only once the supervisor, the CEO and the CFO have all approved.',
          bannerApproved: 'Late day — approved by the supervisor, the CEO and the CFO.',
          // The owner reports to the CEO or the CFO, so the CEO and the CFO sign alone.
          bannerNeededTwo: 'This day is behind the payroll cut-off. Your supervisor is the CEO or the CFO, so it can only be logged by sending it for two approvals — the CEO and the CFO.',
          bannerAwaitingTwo: 'Late day — awaiting two approvals. It is approved only once the CEO and the CFO have both approved.',
          bannerApprovedTwo: 'Late day — approved by the CEO and the CFO.',
          sendTwo: 'Send for 2 approvals',
          confirmBodyTwo: '{{day}} is behind the payroll cut-off. The CEO and the CFO must each approve it, in any order. One refusal is final.',
          // The owner IS the CEO or the CFO, so the other office signs alone.
          bannerNeededOne: 'This day is behind the payroll cut-off. You hold the CEO or the CFO office, so it can only be logged by sending it for one approval — the other office’s.',
          bannerAwaitingOne: 'Late day — awaiting one approval. It is approved once the other office (the CEO or the CFO) has approved.',
          bannerApprovedOne: 'Late day — approved by the other office (the CEO or the CFO).',
          sendOne: 'Send for 1 approval',
          confirmBodyOne: '{{day}} is behind the payroll cut-off. The other office (the CEO or the CFO) must approve it. A refusal is final.',
          bannerRejected: 'Late day — rejected. This is final; it cannot be sent again.',
          bannerBeyond: 'This day is more than one payroll period late and can no longer be sent for approval.',
          bannerFinal: 'This day was rejected automatically, and that is final.',
          bannerPaused: 'This day is behind the payroll cut-off. Sending a late day for co-approval is paused for now — ask HR or an administrator.',
          bannerPayDate: 'Payroll is paid today; you can send this day for approval from {{date}}.',
          send: 'Send for 3 approvals',
          confirmTitle: 'Send a late day for co-approval?',
          confirmBody: '{{day}} is behind the payroll cut-off. Your supervisor, the CEO and the CFO must each approve it, in any order. One refusal is final.',
          cancel: 'Cancel',
          stage: { supervisor: 'Supervisor', ceo: 'CEO', cfo: 'CFO' },
          verdict: { Pending: 'waiting', Approved: 'approved', Rejected: 'rejected', Waived: 'not needed' },
          queueTitle: 'Late days awaiting your approval ({{count}})',
          refusedTitle: 'Late days you rejected ({{count}})',
          refusedHint: 'You rejected these days. Reversing puts your line back to waiting; every other approval stays as it was.',
          refusedReason: 'Your reason: {{reason}}',
          reverse: 'Reverse my refusal ({{stage}})',
          reverseTitle: 'Reverse your refusal?',
          reverseBody: 'This takes back your {{stage}} refusal of {{name}}’s {{day}}. The request re-opens and waits for your approval again.',
          reversed: 'Refusal reversed — the request is open again',
          popupTitle: 'Your co-approval is needed',
          popupBody: 'These days are behind the payroll cut-off. Each counts only once every approval it needs is in — the supervisor, the CEO and the CFO, or just the CEO and the CFO when the supervisor is one of them, or only the other office on the CEO’s or the CFO’s own day.',
          approve: 'Approve',
          reject: 'Refuse',
          reasonPlaceholder: 'Reason (required to refuse)',
          signAs: 'Approve as {{stage}}',
          close: 'Close',
          review: 'Review',
          required: 'This day is behind the payroll cut-off — send it for the three approvals instead.',
          paused: 'Late days cannot be sent for co-approval right now — ask HR or an administrator.',
          // The owner dialog's closed-month sentence, and the generic 409 text.
          closedMonthNote: '{{month}} is a closed payroll month; whether this day can still be approved and paid is decided when you confirm.',
          monthClosed: 'The {{month}} payroll month is closed and this day cannot be approved right now.',
        },
        actualClosedFloor: 'This day is in a payroll period that has closed (before {{floor}}). Ask an administrator to correct it.',
        actualClosedMonth: 'This day is in the {{month}} payroll month ({{start}} – {{end}}), which is closed. Ask an administrator to correct it.',
        actualClosedPayDate: 'Today ({{day}}) is a pay date, so actual logs for {{through}} and earlier cannot be edited, erased or approved. Later days are open as usual. Only a time admin can change one of those today.',
        actualClosedCalendarEnded: 'The pay calendar ended on {{date}}, so only a time admin can change this. Whoever keeps the holiday calendar confirms the next year.',
        backdateClosedPeriodWarning:
          'This day is in a payroll period that has already closed and been paid (before {{floor}}). Saving alone is refused: send the change with the “Send change for approval” button so it can be co-approved.',
        confirmBackdateClosedPeriod:
          'This day is in a payroll period that has already closed and been paid (before {{floor}}). Saving alone is refused and writes nothing; the change has to be sent with the “Send change for approval” button. Continue?',
        decidedBy: 'Last changed by {{name}}', decidedBeforeTracking: 'Decided before tracking began', decidedAutomatically: 'Decided automatically',
        errIncomplete: 'Every line needs a market, an activity and a product or service.',
        errDuplicate: 'Two lines have the same market, activity, product/service, shift and work mode. Merge them or change one.',
        modeMixed: 'Mixed',
        modeMixedHint: "Not every line of this day is logged in the day's work mode. Each line keeps its own until you pick one.",
        errEmptyRow: 'A line has no hours on it.',
        errNegative: 'Hours cannot be negative.',
        errDayTotalLong: 'A day cannot exceed {{max_day_hours}} hours in total.',
        errLimitsLoading: "The hour limits are still loading, so this day can't be saved yet.",
        errDayTotalShort: 'A day cannot exceed {{max_short_transit_day_hours}} hours in total unless more than {{long_transit_over_hours}} of them are transit.',
        errOrdinaryHours: 'Ordinary hours cannot exceed {{max_normal_hours}} in a day.',
        errTransitHours: 'Transit hours cannot exceed {{max_transit_hours}} in a day.',
        errNightHours: 'Nighttime hours (22:00–06:00) cannot exceed {{max_night_hours}}.',
        errOvertimeHours: 'Overtime cannot exceed {{max_overtime_hours}} hours.',
        errDowntime: 'A downtime day is capped at {{max_downtime_hours}} hours with no overtime.',
        errDowntimeNoExtra: 'A downtime day cannot carry overtime, night or OT&NT hours.',
        errDowntimeProjectOnly: 'Downtime can be logged only on a Project product/service.',
        // The day's clock and the gate that pins it to the lines.
        clock: {
          title: 'Hours worked',
          start: 'Start', end: 'End', gap: 'Break', extra: 'Extra',
          startHour: 'Start hour', startMinute: 'Start minute', endHour: 'End hour', endMinute: 'End minute',
          shiftLength: 'Clock', logged: 'Log',
          agrees: 'Balanced',
          required: 'This day logs {{logged}} h, so it needs its start and end time before it can be submitted.',
          none: 'No clock recorded for this day.',
          remove: 'Remove the clock',
          mismatch: 'The lines add up to {{logged}} h but the shift is {{shift}} h. They must agree before this day can be submitted.',
        },
      },
      leave: {
        remaining: {
          title: 'Leave remaining',
          help: 'The balance less every request still awaiting a verdict, this one included while it is pending.',
          pending: '{{days}} pending',
          takenSl: 'SL taken',
          loadFailed: 'Could not load the leave remaining.',
        },
        filters: 'Filters',
        calendarTitle: 'Who is away',
        nobodyAway: 'Nobody is away this month.',
        blockRefused: '{{type}} cannot be raised from October onwards until the mandatory {{days}}-working-day annual leave block is met: this person {{reason}}. Only a leave admin can grant a one-time exception.',
        newRequest: 'New request', type: 'Type of leave', from: 'From', to: 'To',
        // PSL is one day per request (0.5 or 1).
        oneDayOnly: 'Paid sick leave is one day per request — a half day or a whole day.',
        halfDay: 'Half day', reason: 'Reason', requestedDays: 'Requested days',
        pendingDays: 'Already requested, awaiting a verdict',
        afterRequest: 'Balance after', overBalance: 'This is more than the available balance.',
        peerOverlap: 'Overlaps with a peer: {{names}}. {{count}} request(s) clash with these dates.',
        peerOverlapCount: '{{count}} colleague request(s) clash with these dates.',
        selfOverlapCount: 'You already have {{count}} request(s) of your own covering these dates.',
        appointedPeerClash: 'Your peer {{name}} already has leave on these dates ({{from}} – {{to}}). Peers cannot be on leave at the same time, so one of you must move.',
        ledgerAutosave: 'Each cell saves when it loses focus.',
        attachmentHint: 'Medical certificates and similar are attached after the request is raised.',
        submit: 'Submit request',
        reasonMissing: 'Enter a reason for the leave', rangeInvalid: 'The end date is before the start date', submitting: 'Sending the request…', saving: 'Saving…', nothingToSave: 'There is nothing to save',
        dates: 'Dates', requestedOn: 'Requested on', attachments: 'Attachments',
        approvals: 'Approvals', youSign: '(you)',
        stage: { supervisor: 'Supervisor', management: 'CEO', finance: 'CFO' },
        stageNotReached: 'Not yet reached',
        finalRule: 'Final once management has approved and either finance or the supervisor has.',
        trail: { title: 'History', empty: 'No decisions recorded yet.', error: 'The history could not be loaded.' },
        comment: 'Comment', rejectionHint: 'If you reject, say why.',
        rejectedBy: 'Rejected by', reasonRequired: 'A rejection must say why.',
        withdraw: 'Withdraw', requestCancel: 'Request cancellation', stopCancel: 'Stop cancellation',
        resubmit: 'Resubmit', approve: 'Approve', reject: 'Reject',
        approveCancel: 'Approve cancellation', rejectCancel: 'Reject cancellation',
        days: 'Days', status: 'Status', allStatuses: 'All statuses', allTypes: 'All types',
        awaiting: 'Awaiting a decision',
        none: 'No requests',
        noneUnderFilter: 'No requests match these filters.',
        noLeave: 'No leave requests', noLeaveUnderFilter: 'No leave requests match these filters.', showAll: 'Show all ({{count}})',
        overridesLoadFailed: 'Could not load the special permissions:',
        balAl: 'Annual', balCl: 'Casual', balPsl: 'Paid sick', balSpl: 'School police leave', balSl: 'Sick taken', balTakenSl: 'Sick taken',
        balRl: 'Available RL',
        balanceDays: 'Leave balance (days)',
        rlUnavailable: 'no days earned yet',
        ledgerHint: 'Leave balances live here, not on the HR record: approvals move them automatically, and this is where corrections, carry-over and credited prior service are entered.',
        balancesSaved: 'Balances saved',
        created: 'Request submitted', cancelRequested: 'Cancellation requested',
        cancelStopped: 'Cancellation stopped', resubmitted: 'Resubmitted', withdrawn: 'Request withdrawn',
        decidedStage: 'Your approval was recorded', decidedFinal: 'Final status: {{status}}',
        teamBalances: "Your team's leave balances",
        handoverForm: 'While you are away, {{name}} holds: {{rights}}.',
        handoverApprove: 'Approving gives {{name}} these rights until the leave ends: {{rights}}.',
        handoverRefused: '{{name}} is not Full Time, so no rights pass to them during this leave.',
        handoverLoadFailed: 'Could not load what this leave hands over.',
        handoverRoster: 'Roster manager',
        standIn: 'Stand-in', standInDefault: 'Default (HR peer)',
        standInDefaultNamed: 'Default (HR peer: {{name}})',
        standInDefaultNone: 'No eligible peer',
        onBehalfOf: 'Standing in for {{name}}',
        onLeaveToday: 'On leave today',
        onLeaveNone: 'Nobody is on leave today.',
        specialPermission: 'Special leave permission',
        specialPermissionHint: 'A one-time exception letting someone raise paid sick or casual leave from October onwards without having met the mandatory 10-working-day annual leave block.',
        grantSpecialPermission: 'Grant permission',
        specialPermissionGranted: 'Permission granted',
        specialPermissionNone: 'Nobody holds a special leave permission.',
        specialPermissionHistory: 'History',
        stats: 'Statistics',
        statsScope: 'across {{count}} people',
        statsPartial: 'Counts cover only the people whose balances you may read.',
        topAl: 'Most annual leave left',
        fullTimeOnly: 'Full time only',
        showNonFullTime: 'Include part time and contractors',
        peopleAndNumbers: 'People and their balances',
        typeTotals: 'Leave taken, {{year}}',
      },
      timeadmin: {
        revert: 'Revert', logsSaved: 'Saved {{name}}’s day',
        leaveHint: 'Correct a leave record directly — the dates, the type, or the status. Approving requests is a queue and lives on the leave page.',
        requestsOf: 'Leave requests ({{count}})',
        overrideTitle: 'Override a leave rule',
        overrideHint: 'An administrator may pass this rule with a reason. The override is recorded in the audit log with your reason, and the employee — and the peer, when one is involved — is notified.',
        overrideReason: 'Reason for the override',
        overrideConfirm: 'Override and save',
        sectionLogs: 'Actual logs',
        balanceUnsaved: 'Unsaved changes.',
        balanceVersioned: 'Each correction opens a new dated record — the previous balance, and who changed it, are kept.',
        balanceGuide: 'Balance guide',
        balanceGuideOpen: 'Open the balance guide',
        guideEditing: 'What you can correct',
        guideVersioning: 'Corrections are dated',
        guideLedger: 'Where balances live',
        balanceNotANumber: 'A balance has to be a number, and not a negative one.',
        noBalanceRow: 'No leave entitlement is held for this person yet.',
        newProduct: 'New product or service',
        descriptionEn: 'Description (EN)', descriptionMn: 'Description (MN)',
        activities: 'Activities', products: 'Products & services',
        activitiesHint: 'What kind of work a log line was. The Activity choice on every logged line.', activityCount: 'Total: {{count}}', descriptions: 'Descriptions', loadActivitiesFailed: 'Could not load activities', noActivities: 'No activities yet. Add the first one above.', nameRequired: 'Enter a name', pickTargetRequired: 'Pick where the logged lines go', loadProductsFailed: 'Could not load products and services', noProducts: 'No products or services yet. Add the first one above.', loadUsageFailed: 'Could not count the uses', loadPeopleFailed: 'Could not load the people list', moveTargetRequired: 'Pick a product to move to', moveBlocked: 'The server will refuse this move: see the note above', moveNoPreview: 'The counts did not load: pick the product again', loadCalendarFailed: 'Could not load the holidays', loadCutOffsFailed: 'Could not load the salary cut-offs', holidaysTitle: 'Holidays in {{year}}', holidayDate: 'Date', holidayKind: 'Kind', holidayDayOutsideYear: 'Pick a day in {{year}}',
        productsHint: 'What the work was for. The same list the org chart uses.',
        newActivity: 'New entry', addActivity: 'Add', activity: 'Name', typeOf: 'Type',
        active: 'Active', inUse: 'In use', retired: 'Retired', activityAdded: 'Added',
        earnsTransit: 'Transit allowance',
        deleteActivity: 'Delete activity',
        activityRuleBound: 'This activity carries a logging rule and cannot be deleted. Retire it instead.',
        deleteActivityHint: 'Deleting ‘{{activity}}’ moves every log line that uses it onto another activity. This cannot be undone.',
        moveLinesTo: 'Move its log lines to', pickTarget: 'Choose an activity…',
        mergeNothing: 'No log lines use this activity — it will just be removed.',
        mergeSummary: '{{lines}} log lines across {{days}} days become ‘{{target}}’.',
        mergeFolded: '{{count}} of them already have a matching line on the same day and are added into it — hours are kept, the lines are combined.',
        confirmDeleteActivity: 'Delete and move',
        activityDeleted: '‘{{activity}}’ deleted · {{count}} lines moved to ‘{{target}}’',
        impactTitleAdded: 'A holiday on {{day}} falls inside leave',
        impactTitleRemoved: 'Removing the holiday on {{day}} reaches leave',
        impactIntro: 'Choose what happens to each leave. Nothing is saved until every leave has a choice, and each person is told.',
        impactLeaveSpan_one: '{{start}} to {{end}}, {{count}} day',
        impactLeaveSpan_other: '{{start}} to {{end}}, {{count}} days',
        impactChoiceFor: 'Choice for {{name}}',
        impactExtend_one: 'Extend: ends {{end}}, still {{count}} day',
        impactExtend_other: 'Extend: ends {{end}}, still {{count}} days',
        impactMove: 'Move it to {{day}}',
        impactGiveBack_one: 'Give the day back: same dates, {{count}} day',
        impactGiveBack_other: 'Give the day back: same dates, {{count}} days',
        impactGiveBackCancels: 'Give the day back: this cancels the leave',
        impactShorten_one: 'Shorten: ends {{end}}, still {{count}} day',
        impactShorten_other: 'Shorten: ends {{end}}, still {{count}} days',
        impactCharge_one: 'Charge one more day: same dates, {{count}} day',
        impactCharge_other: 'Charge one more day: same dates, {{count}} days',
        impactStuck: 'Neither choice is possible. A leave admin must change the dates of this leave or cancel it; then save this holiday again.',
        impactSave: 'Save holiday',
        impactRefusedOverlap: 'It would run into another leave.',
        impactRefusedClosedMonth: 'It would land in a closed payroll month.',
        impactRefusedPeriodRun: 'It would land in a pay period that has been run.',
        impactRefusedYearUnconfirmed: 'It would land in a year whose calendar is not confirmed.',
        impactRefusedOneDayOnly: 'This leave type can only be one day.',
        impactRefusedOverdraw: 'It would overdraw the balance.',
        impactRefusedResetPaid: 'The January payroll has already paid out this year-end reset.',
        impactRefusedNoWorkingDay: 'This leave holds no working day to shorten.',
        impactRefusedDaysDiffer: 'The stored days do not match the dates, so correct the leave first.',
        impactRefusedMustTake: 'This is the only 10-day annual leave, and there is no room left to take 10 days this year.',
        confirmedAdminOnly: '{{year}} is confirmed, so only an administrator can change its holidays.', confirmYear: 'Confirm {{year}}', yearConfirmed: 'Confirmed', yearUnconfirmed: '{{year}} not confirmed',
        copyYear: 'Copy holidays from {{year}}', copiedCheckDate: 'Same date as {{year}}, check it', copiedMark: 'Check date',
        copyYearDone: 'Copied {{count}} holidays from {{year}}. Check the dates, then confirm.', copyYearSkipped: 'Skipped: {{days}}',
        nationalHoliday: 'National holiday', companyHoliday: 'Company holiday', weekend: 'Weekend',
        holidaysOf: 'Holidays · {{month}} {{year}}', noHolidays: 'No holidays this month.',
        holidayName: 'Holiday name', removeHoliday: 'Remove holiday',
        yearNotImported: 'No calendar was imported for {{year}} — weekends still apply, holidays have to be entered.',
        calendarSaved: 'Calendar saved', calendarReset: 'Calendar restored to the imported list',
        summaryNational: '{{year}} national holidays', summaryCompany: '{{year}} company holidays',
        summaryWorkdays: '{{year}} workdays',
        tabTimeLogging: 'Time logging', tabLeave: 'Leave',
        statPendingDays: 'Pending days', statRejectedDays: 'Rejected days',
        statPendingRequests: 'Pending requests',
        cutOffDay: 'Salary cut-off', cutOffMark: 'Cut-off',
        cutOffsNearby: 'Salary cut-offs', holidaysNearby: 'Holidays',
        listPrevious: 'Previous', listUpcoming: 'Upcoming',
        noCutOffsNearby: 'No salary periods around this month yet.',
        noHolidaysNearby: 'No holidays around this month.',
        paysOn: 'pays {{date}}',
        // A product's uses, moving them, deleting it.
        uses: 'Uses',
        usageTitle: 'Uses of {{product}}',
        usageLoading: 'Counting…',
        useNone: 'Nothing uses this product — it can be deleted.',
        useLines: 'Time-log lines: {{count}}',
        useRoles: 'Staff product roles: {{count}}',
        usePlannedDays: 'Planned roster days: {{count}}',
        useActualDays: 'Actual roster days: {{count}}',
        useLogDays: 'Logged roster days: {{count}}',
        useExternalProjects: 'Contractor records with it as a project: {{count}}',
        useRosterCells: 'Roster cells under its Mongolian name: {{count}}',
        usageSpan: 'Filled in by {{people}} people, {{first}} – {{last}}.',
        usageClosedLines: '{{count}} of the lines are in closed payroll months.',
        usageRosterRow: 'On the roster as “{{name}}”.',
        showPeople: 'Who filled it in',
        hidePeople: 'Hide the people',
        colPerson: 'Person',
        colDays: 'Days',
        colHours: 'Hours',
        colSpan: 'First – last day',
        moveTitle: 'Move these uses to another product',
        moveHint: 'Every line, role and project name moves to the product you pick. Lines that already have a matching line on the same day are added into it. Pick a target to see the counts first.',
        moveRefusedAhead: '{{count}} line(s) are in closed payroll months and the target differs in: {{settings}}. Moving them would change closed pay, so the move will be refused. Pick a product with the same settings, or retire this one instead.',
        typicalShiftHours: 'Typical shift hours', pickProduct: 'Choose a product…',
        movePreviewLines: '{{lines}} time-log line(s) move to {{target}}; {{merged}} of them are added into an existing line.',
        movePreviewRoles: '{{moved}} role(s) move; {{skipped}} are dropped because the person already has a role on the target.',
        movePreviewCopies: '{{days}} roster day(s) and {{records}} personnel record(s) get the new project name.',
        moveRosterMoved: 'Its roster entry moves to the target.',
        moveRosterDropped: 'The target has its own roster entry, so this one is removed.',
        confirmMove: 'Move',
        moved: 'Moved every use of {{source}} to {{target}}',
        deleteProductHint: 'Nothing uses this product any more. Deleting it removes it for good.',
        deleteProductBlocked: 'It can be deleted only once nothing uses it — move the uses above first, or retire it with the Active box instead.',
        deleteProduct: 'Delete product',
        confirmDeleteProduct: 'Delete for good',
        productDeleted: 'Deleted {{product}}',
      },
  },
  ru: {
      time: {
        // Статус заявок, ожидающих решения слишком долго.
        backlog: {
          whySelf: 'Вы сами подали эту заявку и не можете её решать.',
          whyNotYourStage: 'У вас нет прав на этот этап согласования.',
          whyPastPayrollReach: 'Решение, принятое сейчас, не изменит ни один открытый расчёт зарплаты.',
          whyUnavailable: 'По этой строке решение сейчас недоступно.',
        },
        scope: 'Охват', scope_own: 'Мои', scope_team: 'Моя команда', scope_all: 'Все',
        scope_own_short: 'Мои', scope_team_short: 'Команда', scope_all_short: 'Все',
        filterLast60: 'За 60 дней: {{n}}',
        scope_awaiting: 'Подчинённые', scope_awaiting_short: 'Подчинённые',
        scope_admin: 'Все', scope_admin_short: 'Все',
        scope_backlog: 'Просроченные', scope_backlog_short: 'Просроч.',
        prev: 'Назад', next: 'Вперёд', today: 'Сегодня',
        pay: {
          // Заголовок, отличающий строку от легенды ниже.
          heading: 'Зарплата',
          cutOff: 'Отсечка', payDate: 'Выплата',
        },
        saved: 'Сохранено',
        loadFailed: 'Не удалось загрузить этот день. Пока сохранять небезопасно.',
        retry: 'Повторить',
        peopleLoadFailed: 'Не удалось загрузить список сотрудников.',
        noEmployeeRecord: 'Ваш вход не связан с карточкой сотрудника. Обратитесь в отдел кадров.',
        day: 'День', mode: 'Режим работы', activity: 'Направление', total: 'Итого',
        market: 'Юрлицо', product: 'Проект', hours: 'Часы', comment: 'Комментарий',
        // Market and product are the log line's Entity and Project dropdowns.
        allProducts: 'Все продукты и услуги',
        shift: 'Смена', shiftDay: 'День', shiftNight: 'Ночь',
        field: {
          overtime_hours: 'Сверхурочные', nighttime_hours: 'Ночные',
          over_night_hours: 'Ночь + СУ', transit_hours: 'В пути',
        },
        dayTotal: 'Итого за день', addLine: 'Добавить строку', removeLine: 'Удалить строку',
        noLines: 'За этот день ничего не записано.',
        downtimeHint: 'День простоя: не больше {{max_downtime_hours}} ч и без сверхурочных.',
        downtimeHintCapped: 'В день простоя нет сверхурочных и ночных часов. Простой оплачивается только до типовой смены проекта.',
        showExtraHours: 'Добавить сверхурочные и ночные часы',
        dow: { 0: 'Вс', 1: 'Пн', 2: 'Вт', 3: 'Ср', 4: 'Чт', 5: 'Пт', 6: 'Сб' },
        month: { 0: 'Январь', 1: 'Февраль', 2: 'Март', 3: 'Апрель', 4: 'Май', 5: 'Июнь', 6: 'Июль', 7: 'Август', 8: 'Сентябрь', 9: 'Октябрь', 10: 'Ноябрь', 11: 'Декабрь' },
        status: {
          Draft: 'Черновик', Pending: 'На утверждении', Approved: 'Утверждено', Rejected: 'Отклонено',
          'Cancel Pending': 'Отмена на рассмотрении', Cancelled: 'Отменено',
          'Cancel Approved': 'Отмена утверждена', 'Cancel Rejected': 'Отмена отклонена',
        },
        statusHeading: 'Статус', kind: 'Тип записи', kindPlan: 'План', kindActual: 'Факт',
        // Where each mark sits in a day cell.
        backToCalendar: 'Календарь', fillIn: 'Заполнить',
        legendKey: 'Обозначения', factoredHours: 'С коэффициентами', hoursOne: '{{hours}} ч', hoursBoth: 'заявлено {{reported}} ч, с коэффициентами {{factored}} ч', legendFactoredDiffers: 'часы с коэффициентами и заявленные различаются', legendActualWhere: 'основная цифра дня', legendPlanWhere: 'пунктирная метка в углу',
        hoursTotal: 'Всего {{hours}} ч',
        copyPlan: 'Скопировать план', copyActual: 'Скопировать факт', removeLogs: 'Очистить день',
        submit: 'Отправить', resubmit: 'Отправить снова',
        // Поле причины рядом с кнопкой отклонения.
        rejectReason: 'Причина отклонения',
        rejectReasonHint: 'Укажите, что нужно исправить',
        rejectApproved: 'Отклонить…',
        rejectApprovedSend: 'Отклонить день',
        remotePlanNotApproved:
          'Утверждённого плана удалённой работы нет — руководитель увидит это при утверждении.',
        noApprovedPlan: 'Нет утверждённого плана',
        noApprovedPlanHint: 'День отмечен как удалённая работа или работа из дома, но утверждённого плана на него нет.',
        draft: 'Черновик',
        copiedPlan: 'Скопировано', cleared: 'День очищен',
        erased: 'День удалён',
        savedPendingToDraft: 'Сохранено как черновик. Пока вы не отправите день снова, он не в очереди на согласование.',
        pastPendingNote: 'Этот день до отсечки расчёта зарплаты. После сохранения или отправки его согласует администратор времени.',
        savedForTimeAdmin: 'Сохранено. День до отсечки расчёта зарплаты, поэтому он ждёт согласования администратора времени.',
        confirmResubmit:
          'Этот день уже утверждён. Сохранение отменит утверждение, и день потребуется утвердить заново. Продолжить?',
        confirmReapproval:
          'Этот день уже утверждён. Повторная отправка вернёт его в статус «Ожидает», и утверждающий должен будет утвердить его снова. До этого он не учитывается в зарплате. Продолжить?',
        confirmErase:
          'Удалить этот день полностью? Режим работы и все записи будут удалены, отменить это нельзя.',
        editedPending: 'Запись успешно изменена',
        submitted: 'Отправлено на утверждение', approved: 'Утверждено', rejected: 'Отклонено',
        planPick: 'Нажимайте на даты в календаре, чтобы добавить их в план.',
        // Выбранные дни отмечаются в календаре.
        planSelectedOnCalendar: 'В календаре отмечено дней: {{count}}',
        planClear: 'Снять выбор',
        planSubmitted: 'План на {{count}} дней отправлен',
        planAppliesTo: 'Эта запись будет применена одинаково к {{count}} дням: {{dates}}',
        batchApproved: 'Утверждено дней: {{count}}',
        batchPartial: 'Утверждено: {{done}}, не утверждено: {{failed}}',
        approveNothingLeft: 'Эти дни уже рассмотрены.',
        referencePlan: 'План (только просмотр)',
        findPerson: 'Найти сотрудника', noSupervisees: 'У вас нет подчинённых', coveringFor: 'Замещаете: {{name}}', coveringUntil: 'до {{date}}', noPeople: 'Сотрудники не найдены',
        nothingAwaiting: 'Нет заявок, ожидающих вашего решения',
        awaitingMarker: '{{days}} д · {{hours}} ч',
        awaitingCurrentMarkerTitle: 'На согласовании в текущем расчётном периоде: {{days}} дн., всего {{hours}} ч',
        awaitingPastMarker: '{{days}} д',
        awaitingPastMarkerTitle: 'Всё ещё на согласовании из прошлых расчётных периодов: {{days}} дн.',
        noHourlySupervisees:
          'Нет подчинённых для показа. Сотрудники с почасовой оплатой показаны всегда; сотрудники на окладе — пока у них есть день, ожидающий решения.',
        noHourlyPeople:
          'Сотрудники не найдены. В этом списке показаны сотрудники с почасовой оплатой, а также сотрудники на окладе, пока у них есть день, ожидающий решения.',
        nothingToApprove: 'За этот день нечего утверждать.',
        bulkApproveTitle: 'Дни, ожидающие утверждения',
        bulkApproveAll: 'Выбрать все',
        bulkApproveClear: 'Снять выбор',
        bulkApproveAction: 'Утвердить выбранные ({{count}})',
        bulkApproveDone: 'Утверждено дней: {{count}}',
        bulkApproveRefusedTitle: 'Не утверждены',
        bulkApproveRefusedLine: '{{day}}: {{detail}}',
        // The owner sees why a day was sent back.
        sentBack: {
          title: 'Дни, возвращённые вам',
          hint: 'Нажмите на день, чтобы открыть его и увидеть, что можно сделать дальше.',
          reason: 'Причина:',
          line: '{{day}} ({{kind}}): {{reason}}',
          cell: 'Причина: {{reason}}',
          canResubmit: 'этот день можно исправить и отправить снова',
        },
        // The one approve/reject bar at the bottom of the page.
        approvalBar: {
          hintPlan: 'Ожидающие дни плана отмечены в календаре заранее. Снимите отметку с тех, что не решаете; «Утвердить» и «Отклонить» действуют только на отмеченные дни.',
          hintActual: 'Отметьте в календаре дни факта, которые решаете; заранее ничего не отмечено. «Утвердить» и «Отклонить» действуют только на отмеченные дни.',
          // The approve tick on a calendar cell.
          tickDay: 'Отметить {{day}} для решения',
        },
        blocked: { noLines: 'Сначала добавьте строку', errors: 'Сначала исправьте ошибки в строках', clock: 'Время по часам не совпадает со строками', clockMissing: 'Сначала укажите время начала и окончания', busy: 'Сохранение…', nothingToSave: 'Нечего сохранять', noPlanDates: 'Сначала выберите день в календаре' },
        // The supervisor picks days on the calendar.
        pick: {
          reject: 'Отклонить выбранные ({{count}})',
          sharedReason: 'Причина отклонения для всех выбранных дней',
          rejectDone: 'Отклонено дней: {{count}}',
          rejectRefusedTitle: 'Не отклонены',
          whyApprove: 'Утвердить: {{reason}}',
          whyReject: 'Отклонить: {{reason}}',
          enterFor: 'Внести время за {{name}}',
          enterApproved: 'То, что вы сохраните за этого сотрудника, сразу записывается как утверждённое.',
          cell: {
            checking: 'Ещё загружается, этот день пока нельзя выбрать.',
            empty: 'За этот день ничего не внесено, утверждать нечего.',
            notPending: 'Выбрать можно только ожидающие дни.',
            notDecidable: 'По этому ожидающему дню здесь нельзя принять решение.',
          },
          toggle: {
            checking: 'Загрузка.',
            nonePending: 'На этой вкладке нет дней, ожидающих вашего решения.',
          },
          batch: {
            nonePending: 'На этой вкладке нет дней, ожидающих вашего решения.',
            noneSelected: 'Сначала отметьте хотя бы один ожидающий день.',
            working: 'Отправка решения…',
            unsavedEdit: 'Сначала сохраните или отмените изменение открытого дня.',
            reasonRequired: 'Укажите причину отклонения; сотрудник увидит её на каждом отмеченном дне.',
          },
          save: {
            outsidePeriod: 'Руководитель может менять только дни текущего расчётного периода.',
            noChange: 'Пока ничего не изменено.',
            fixErrors: 'Сначала исправьте ошибки, показанные в строках.',
            saving: 'Сохранение…',
          },
          enter: {
            checking: 'Загрузка.',
            planNotWritable: 'Руководитель может вносить фактическое время сотрудника, но не его план.',
            payDateLocked: 'Сегодня день выплаты, поэтому фактическое время за этот день заблокировано.',
            calendarEnded: 'Календарь выплат закончился, поэтому фактическое время за этот день может внести только администратор времени.',
            future: 'Этот день ещё не наступил.',
            beforePeriod: 'Этот день раньше {{floor}} — самой ранней даты, за которую вы можете вносить время.',
          },
        },
        planClosed: 'План вносится только на сегодня и далее.',
        planNeedsALine: 'Добавьте хотя бы одну строку перед отправкой плана — показанная строка является подсказкой и не сохранена.',
        actualClosed: 'Фактические часы вносятся за последние семь дней. Более старое исправляет администратор.',
        // Опоздавший день подписывают трое.
        cosign: {
          bannerNeeded: 'Этот день позже отсечки по зарплате. Его можно внести только через три согласования — руководителя, генерального и финансового директоров.',
          bannerNeededEdit: 'Этот день позже отсечки по зарплате. Изменение чужого позднего дня отправляется на согласование руководителю, генеральному и финансовому директорам; ваше собственное согласование считается данным.',
          sendEdit: 'Отправить изменение на согласование',
          confirmBodyEdit: '{{day}} позже отсечки по зарплате. Изменение отправляется на согласование руководителю, генеральному и финансовому директорам; ваше собственное согласование считается данным, остальные согласуют каждый, в любом порядке. Один отказ окончателен.',
          requiredEdit: 'Этот день позже отсечки по зарплате, поэтому изменение нельзя сохранить напрямую — нажмите «Отправить изменение на согласование».',
          bannerAwaiting: 'Опоздавший день — ожидает трёх согласований. Он будет утверждён только после согласования руководителя, генерального и финансового директоров.',
          bannerApproved: 'Опоздавший день — утверждён руководителем, генеральным и финансовым директорами.',
          // The owner reports to the CEO or the CFO, so the CEO and the CFO sign alone.
          bannerNeededTwo: 'Этот день позже отсечки по зарплате. Ваш руководитель — генеральный или финансовый директор, поэтому его можно внести только через два согласования — генерального и финансового директоров.',
          bannerAwaitingTwo: 'Опоздавший день — ожидает двух согласований. Он будет утверждён только после согласования генерального и финансового директоров.',
          bannerApprovedTwo: 'Опоздавший день — утверждён генеральным и финансовым директорами.',
          sendTwo: 'Отправить на 2 согласования',
          confirmBodyTwo: '{{day}} позже отсечки по зарплате. Генеральный и финансовый директора должны утвердить его, в любом порядке. Один отказ окончателен.',
          // The owner IS the CEO or the CFO, so the other office signs alone.
          bannerNeededOne: 'Этот день позже отсечки по зарплате. Вы — генеральный или финансовый директор, поэтому его можно внести только через одно согласование — другого директора.',
          bannerAwaitingOne: 'Опоздавший день — ожидает одного согласования. Он будет утверждён после согласования другого директора (генерального или финансового).',
          bannerApprovedOne: 'Опоздавший день — утверждён другим директором (генеральным или финансовым).',
          sendOne: 'Отправить на 1 согласование',
          confirmBodyOne: '{{day}} позже отсечки по зарплате. Другой директор (генеральный или финансовый) должен его утвердить. Отказ окончателен.',
          bannerRejected: 'Опоздавший день — отклонён. Это окончательно; отправить повторно нельзя.',
          bannerBeyond: 'Этот день опоздал более чем на один период начисления зарплаты и больше не может быть отправлен на согласование.',
          bannerFinal: 'Этот день был отклонён автоматически, и это окончательно.',
          bannerPaused: 'Этот день позже отсечки по зарплате. Отправка опоздавших дней на согласование временно приостановлена — обратитесь в отдел кадров или к администратору.',
          bannerPayDate: 'Сегодня выплачивается зарплата; отправить этот день на согласование можно с {{date}}.',
          send: 'Отправить на 3 согласования',
          confirmTitle: 'Отправить опоздавший день на согласование?',
          confirmBody: '{{day}} позже отсечки по зарплате. Руководитель, генеральный и финансовый директора должны утвердить его, в любом порядке. Один отказ окончателен.',
          cancel: 'Отмена',
          stage: { supervisor: 'Руководитель', ceo: 'Ген. директор', cfo: 'Фин. директор' },
          verdict: { Pending: 'ожидает', Approved: 'утверждено', Rejected: 'отклонено', Waived: 'не требуется' },
          queueTitle: 'Опоздавшие дни, ожидающие вашего согласования ({{count}})',
          refusedTitle: 'Опоздавшие дни, которые вы отклонили ({{count}})',
          refusedHint: 'Вы отклонили эти дни. Отмена вернёт вашу строку в ожидание; остальные согласования останутся как были.',
          refusedReason: 'Ваша причина: {{reason}}',
          reverse: 'Отменить мой отказ ({{stage}})',
          reverseTitle: 'Отменить ваш отказ?',
          reverseBody: 'Ваш отказ ({{stage}}) по дню {{day}} сотрудника {{name}} будет отменён. Заявка снова откроется и будет ждать вашего согласования.',
          reversed: 'Отказ отменён — заявка снова открыта',
          popupTitle: 'Нужно ваше согласование',
          popupBody: 'Эти дни позже отсечки по зарплате. Каждый засчитывается только после всех нужных согласований — руководителя, генерального и финансового директоров, или только генерального и финансового, если руководитель — один из них, а собственный день генерального или финансового директора — только другой директор.',
          approve: 'Утвердить',
          reject: 'Отклонить',
          reasonPlaceholder: 'Причина (обязательна для отказа)',
          signAs: 'Утвердить как {{stage}}',
          close: 'Закрыть',
          review: 'Открыть',
          required: 'Этот день позже отсечки по зарплате — отправьте его на три согласования.',
          paused: 'Опоздавшие дни сейчас нельзя отправить на согласование — обратитесь в отдел кадров или к администратору.',
          // The owner dialog's closed-month sentence, and the generic 409 text.
          closedMonthNote: 'Месяц {{month}} закрыт; можно ли ещё утвердить и оплатить этот день, решается при подтверждении.',
          monthClosed: 'Платёжный месяц {{month}} закрыт, и этот день сейчас нельзя утвердить.',
        },
        actualClosedFloor: 'Этот день относится к закрытому периоду начисления зарплаты (до {{floor}}). Исправление внесёт администратор.',
        actualClosedMonth: 'Этот день относится к платёжному месяцу {{month}} ({{start}} – {{end}}), который закрыт. Исправление внесёт администратор.',
        actualClosedPayDate: 'Сегодня ({{day}}) день выплаты зарплаты, поэтому фактические записи за {{through}} и ранее нельзя изменить, удалить или утвердить. Последующие дни открыты как обычно. Это может сделать только администратор времени.',
        actualClosedCalendarEnded: 'Календарь выплат закончился {{date}}, поэтому это может изменить только администратор времени. Следующий год подтверждает тот, кто ведёт календарь праздников.',
        backdateClosedPeriodWarning:
          'Этот день относится к периоду начисления зарплаты, который уже закрыт и оплачен (до {{floor}}). Одно сохранение будет отклонено: отправьте изменение кнопкой «Отправить изменение на согласование», чтобы его согласовали совместно.',
        confirmBackdateClosedPeriod:
          'Этот день относится к периоду начисления зарплаты, который уже закрыт и оплачен (до {{floor}}). Одно сохранение будет отклонено и ничего не запишет; изменение нужно отправить кнопкой «Отправить изменение на согласование». Продолжить?',
        decidedBy: 'Последнее изменение: {{name}}', decidedBeforeTracking: 'Решение принято до начала отслеживания', decidedAutomatically: 'Решение принято автоматически',
        errIncomplete: 'В каждой строке нужны рынок, направление и продукт или услуга.',
        errDuplicate: 'У двух строк одинаковые рынок, вид деятельности, продукт/услуга, смена и режим работы. Объедините или измените одну.',
        modeMixed: 'Смешанный',
        modeMixedHint: 'Не все строки этого дня записаны в режиме работы дня. Каждая сохраняет свой, пока вы не выберете один.',
        errEmptyRow: 'В строке не указаны часы.',
        errNegative: 'Часы не могут быть отрицательными.',
        errDayTotalLong: 'За день нельзя внести больше {{max_day_hours}} ч.',
        errLimitsLoading: 'Лимиты часов ещё загружаются, поэтому этот день пока нельзя сохранить.',
        errDayTotalShort: 'За день нельзя внести больше {{max_short_transit_day_hours}} ч, если из них в пути не больше {{long_transit_over_hours}} ч.',
        errOrdinaryHours: 'Обычных часов не может быть больше {{max_normal_hours}} в день.',
        errTransitHours: 'Часов в пути не может быть больше {{max_transit_hours}} в день.',
        errNightHours: 'Ночных часов (22:00–06:00) не может быть больше {{max_night_hours}}.',
        errOvertimeHours: 'Сверхурочных не может быть больше {{max_overtime_hours}} ч.',
        errDowntime: 'День простоя: не больше {{max_downtime_hours}} ч и без сверхурочных.',
        errDowntimeNoExtra: 'В день простоя нельзя указывать сверхурочные, ночные часы или их сочетание.',
        errDowntimeProjectOnly: 'Простой можно указывать только по продукту/услуге типа «Проект».',
        // The day's clock and the gate that pins it to the lines.
        clock: {
          title: 'Отработанные часы',
          start: 'Начало', end: 'Конец', gap: 'Перерыв', extra: 'Дополнительно',
          startHour: 'Час начала', startMinute: 'Минута начала', endHour: 'Час конца', endMinute: 'Минута конца',
          shiftLength: 'Отметка', logged: 'Журнал',
          agrees: 'Совпадает',
          required: 'В этот день указано {{logged}} ч, поэтому перед отправкой нужно указать время начала и окончания.',
          none: 'За этот день время не отмечено.',
          remove: 'Удалить отметку времени',
          mismatch: 'Строки дают {{logged}} ч, а смена — {{shift}} ч. Перед отправкой они должны совпадать.',
        },
      },
      leave: {
        remaining: {
          title: 'Остаток отпуска',
          help: 'Баланс за вычетом всех заявок, ожидающих решения, включая эту, пока она не решена.',
          pending: 'ожидает: {{days}}',
          takenSl: 'Взято SL',
          loadFailed: 'Не удалось загрузить остаток отпуска.',
        },
        filters: 'Фильтры',
        calendarTitle: 'Кто отсутствует',
        nobodyAway: 'В этом месяце никто не отсутствует.',
        blockRefused: '{{type}} нельзя оформить с октября, пока не выполнен обязательный блок ежегодного отпуска в {{days}} рабочих дней. Разовое исключение может предоставить только администратор отпусков.',
        newRequest: 'Новая заявка', type: 'Тип отпуска', from: 'С', to: 'По',
        // PSL is one day per request (0.5 or 1).
        oneDayOnly: 'Оплачиваемый больничный — один день на заявку: полдня или целый день.',
        halfDay: 'Полдня', reason: 'Причина', requestedDays: 'Запрошено дней',
        pendingDays: 'Уже запрошено, ожидает решения',
        afterRequest: 'Остаток после', overBalance: 'Больше, чем доступный остаток.',
        peerOverlap: 'Пересечение с коллегами: {{names}}. Совпадает заявок: {{count}}.',
        peerOverlapCount: 'Заявок коллег, пересекающихся с этими датами: {{count}}.',
        selfOverlapCount: 'Ваших собственных заявок на эти даты: {{count}}.',
        appointedPeerClash: 'Ваш напарник {{name}} уже в отпуске в эти даты ({{from}} – {{to}}). Напарники не могут отсутствовать одновременно, поэтому одному из вас нужно перенести даты.',
        ledgerAutosave: 'Каждое поле сохраняется при потере фокуса.',
        attachmentHint: 'Справки и другие документы прикладываются после создания заявки.',
        submit: 'Отправить заявку',
        reasonMissing: 'Укажите причину отпуска', rangeInvalid: 'Дата окончания раньше даты начала', submitting: 'Заявка отправляется…', saving: 'Сохранение…', nothingToSave: 'Нечего сохранять',
        dates: 'Даты', requestedOn: 'Дата заявки', attachments: 'Вложения',
        approvals: 'Утверждения', youSign: '(вы)',
        stage: { supervisor: 'Руководитель', management: 'ГД', finance: 'ФД' },
        stageNotReached: 'Ещё не дошло',
        finalRule: 'Заявка утверждается окончательно после руководства и либо финансов, либо непосредственного руководителя.',
        trail: { title: 'История', empty: 'Решений пока нет.', error: 'Не удалось загрузить историю.' },
        comment: 'Комментарий', rejectionHint: 'При отклонении укажите причину.',
        rejectedBy: 'Отклонил:', reasonRequired: 'Для отклонения укажите причину.',
        withdraw: 'Отозвать', requestCancel: 'Подать заявку на отмену', stopCancel: 'Отменить заявку',
        resubmit: 'Отправить снова', approve: 'Утвердить', reject: 'Отклонить',
        approveCancel: 'Утвердить отмену', rejectCancel: 'Отклонить отмену',
        days: 'Дней', status: 'Статус', allStatuses: 'Все статусы', allTypes: 'Все типы',
        awaiting: 'Ожидают решения',
        none: 'Заявок нет',
        noneUnderFilter: 'Нет заявок по этим фильтрам.',
        noLeave: 'Заявок на отпуск нет', noLeaveUnderFilter: 'Нет заявок на отпуск по этим фильтрам.', showAll: 'Показать все ({{count}})',
        overridesLoadFailed: 'Не удалось загрузить особые разрешения:',
        balAl: 'Ежегодный', balCl: 'Обычный отгул', balPsl: 'Оплач. больничный', balSpl: 'Отпуск школьной полиции',
        balSl: 'Больничных взято', balTakenSl: 'Больничных взято', balRl: 'Доступно RL',
        balanceDays: 'Остаток отпуска (дни)',
        rlUnavailable: 'дни ещё не начислены',
        ledgerHint: 'Остатки отпуска живут здесь, а не в карточке сотрудника: утверждения меняют их автоматически, а корректировки, переносы и зачёт прежнего стажа вносятся отсюда.',
        balancesSaved: 'Остатки сохранены',
        created: 'Заявка отправлена', cancelRequested: 'Запрошена отмена',
        cancelStopped: 'Заявка на отмену снята', resubmitted: 'Отправлено повторно', withdrawn: 'Заявка отозвана',
        decidedStage: 'Ваше решение записано', decidedFinal: 'Итоговый статус: {{status}}',
        teamBalances: 'Остатки отпусков вашей команды',
        handoverForm: 'Пока вас нет, {{name}} получает права: {{rights}}.',
        handoverApprove: 'После одобрения {{name}} получает до конца отпуска права: {{rights}}.',
        handoverRefused: '{{name}} не в штате, поэтому на время отпуска права не передаются.',
        handoverLoadFailed: 'Не удалось загрузить, какие права передаёт этот отпуск.',
        handoverRoster: 'Менеджер графика',
        standIn: 'Заместитель', standInDefault: 'По умолчанию (кадровый напарник)',
        standInDefaultNamed: 'По умолчанию (кадровый напарник: {{name}})',
        standInDefaultNone: 'Нет подходящего напарника',
        onBehalfOf: 'Замещаете {{name}}',
        onLeaveToday: 'В отпуске сегодня',
        onLeaveNone: 'Сегодня никто не в отпуске.',
        specialPermission: 'Особое разрешение на отпуск',
        specialPermissionHint: 'Разовое исключение: позволяет с октября брать оплачиваемый больничный или обычный отгул, не отгуляв обязательный блок из 10 рабочих дней ежегодного отпуска.',
        grantSpecialPermission: 'Выдать разрешение',
        specialPermissionGranted: 'Разрешение выдано',
        specialPermissionNone: 'Ни у кого нет особого разрешения.',
        specialPermissionHistory: 'История',
        stats: 'Статистика',
        statsScope: 'по {{count}} сотрудникам',
        statsPartial: 'Учтены только те, чьи балансы вам доступны.',
        topAl: 'Больше всего ежегодного отпуска',
        fullTimeOnly: 'Только полная занятость',
        showNonFullTime: 'Показать частичную занятость и подрядчиков',
        peopleAndNumbers: 'Сотрудники и их балансы',
        typeTotals: 'Использованный отпуск за {{year}} год',
      },
      timeadmin: {
        revert: 'Вернуть', logsSaved: 'День сотрудника {{name}} сохранён',
        leaveHint: 'Правка записи об отпуске напрямую — даты, тип, статус. Утверждение заявок — это очередь, она на странице отпусков.',
        requestsOf: 'Заявки на отпуск ({{count}})',
        overrideTitle: 'Обойти правило отпуска',
        overrideHint: 'Администратор может обойти это правило, указав причину. Обход записывается в журнал аудита вместе с причиной, а сотрудник — и коллега-напарник, если он затронут, — получают уведомление.',
        overrideReason: 'Причина обхода',
        overrideConfirm: 'Обойти и сохранить',
        sectionLogs: 'Факт по дням',
        balanceUnsaved: 'Есть несохранённые изменения.',
        balanceVersioned: 'Каждое исправление создаёт новую запись с датой — прежний остаток и автор изменения сохраняются.',
        balanceGuide: 'Справка по остаткам',
        balanceGuideOpen: 'Открыть справку по остаткам',
        guideEditing: 'Что можно исправить',
        guideVersioning: 'Исправления датируются',
        guideLedger: 'Где хранятся остатки',
        balanceNotANumber: 'Остаток должен быть числом, и не отрицательным.',
        noBalanceRow: 'Для этого сотрудника ещё нет записи об отпускных правах.',
        newProduct: 'Новый продукт или услуга',
        descriptionEn: 'Описание (EN)', descriptionMn: 'Описание (МН)',
        activities: 'Направления', products: 'Продукты и услуги',
        activitiesHint: 'Каким видом работы была строка табеля.', activityCount: 'Всего: {{count}}', descriptions: 'Описания', loadActivitiesFailed: 'Не удалось загрузить виды работ', noActivities: 'Видов работ пока нет. Добавьте первый выше.', nameRequired: 'Введите название', pickTargetRequired: 'Выберите, куда перенести строки', loadProductsFailed: 'Не удалось загрузить продукты и услуги', noProducts: 'Продуктов и услуг пока нет. Добавьте первый выше.', loadUsageFailed: 'Не удалось подсчитать использование', loadPeopleFailed: 'Не удалось загрузить список людей', moveTargetRequired: 'Выберите продукт для переноса', moveBlocked: 'Сервер откажет в этом переносе: см. примечание выше', moveNoPreview: 'Подсчёт не загрузился: выберите продукт ещё раз', loadCalendarFailed: 'Не удалось загрузить праздники', loadCutOffsFailed: 'Не удалось загрузить даты закрытия зарплаты', holidaysTitle: 'Праздники {{year}} года', holidayDate: 'Дата', holidayKind: 'Тип', holidayDayOutsideYear: 'Выберите день в {{year}} году',
        productsHint: 'Для чего выполнялась работа. Тот же список, что и в оргструктуре.',
        newActivity: 'Новая запись', addActivity: 'Добавить', activity: 'Название', typeOf: 'Категория',
        active: 'Активно', inUse: 'Используется', retired: 'Архив', activityAdded: 'Добавлено',
        earnsTransit: 'Транспортная надбавка',
        deleteActivity: 'Удалить',
        activityRuleBound: 'С этой активностью связано правило учёта — удалить нельзя. Переведите её в архив.',
        deleteActivityHint: 'Удаление «{{activity}}» переносит все строки табеля на другую активность. Отменить нельзя.',
        moveLinesTo: 'Перенести строки в', pickTarget: 'Выберите активность…',
        mergeNothing: 'Строк с этой активностью нет — она просто удалится.',
        mergeSummary: '{{lines}} строк за {{days}} дней станут «{{target}}».',
        mergeFolded: 'Из них {{count}} совпадают со строкой того же дня и будут объединены — часы сохраняются, строки складываются.',
        confirmDeleteActivity: 'Удалить и перенести',
        activityDeleted: '«{{activity}}» удалена · {{count}} строк перенесено в «{{target}}»',
        impactTitleAdded: 'Праздник {{day}} попадает на отпуск',
        impactTitleRemoved: 'Снятие праздника {{day}} затрагивает отпуск',
        impactIntro: 'Выберите, что будет с каждым отпуском. Ничего не сохранится, пока выбор не сделан для всех, и каждый сотрудник получит уведомление.',
        impactLeaveSpan_one: '{{start}} - {{end}}, {{count}} день',
        impactLeaveSpan_few: '{{start}} - {{end}}, {{count}} дня',
        impactLeaveSpan_many: '{{start}} - {{end}}, {{count}} дней',
        impactLeaveSpan_other: '{{start}} - {{end}}, {{count}} дня',
        impactChoiceFor: 'Выбор для: {{name}}',
        impactExtend_one: 'Продлить: до {{end}}, по-прежнему {{count}} день',
        impactExtend_few: 'Продлить: до {{end}}, по-прежнему {{count}} дня',
        impactExtend_many: 'Продлить: до {{end}}, по-прежнему {{count}} дней',
        impactExtend_other: 'Продлить: до {{end}}, по-прежнему {{count}} дня',
        impactMove: 'Перенести на {{day}}',
        impactGiveBack_one: 'Вернуть день: те же даты, {{count}} день',
        impactGiveBack_few: 'Вернуть день: те же даты, {{count}} дня',
        impactGiveBack_many: 'Вернуть день: те же даты, {{count}} дней',
        impactGiveBack_other: 'Вернуть день: те же даты, {{count}} дня',
        impactGiveBackCancels: 'Вернуть день: этот отпуск будет отменён',
        impactShorten_one: 'Сократить: до {{end}}, по-прежнему {{count}} день',
        impactShorten_few: 'Сократить: до {{end}}, по-прежнему {{count}} дня',
        impactShorten_many: 'Сократить: до {{end}}, по-прежнему {{count}} дней',
        impactShorten_other: 'Сократить: до {{end}}, по-прежнему {{count}} дня',
        impactCharge_one: 'Списать ещё один день: те же даты, {{count}} день',
        impactCharge_few: 'Списать ещё один день: те же даты, {{count}} дня',
        impactCharge_many: 'Списать ещё один день: те же даты, {{count}} дней',
        impactCharge_other: 'Списать ещё один день: те же даты, {{count}} дня',
        impactStuck: 'Оба варианта невозможны. Администратор отпусков должен изменить даты этого отпуска или отменить его; затем сохраните праздник снова.',
        impactSave: 'Сохранить праздник',
        impactRefusedOverlap: 'Он пересечётся с другим отпуском.',
        impactRefusedClosedMonth: 'Он попадёт в закрытый расчётный месяц.',
        impactRefusedPeriodRun: 'Он попадёт в уже рассчитанный период.',
        impactRefusedYearUnconfirmed: 'Он попадёт в год с неподтверждённым календарём.',
        impactRefusedOneDayOnly: 'Этот вид отпуска может быть только на один день.',
        impactRefusedOverdraw: 'Баланс уйдёт в минус.',
        impactRefusedResetPaid: 'Январская зарплата уже выплатила этот итог закрытия года.',
        impactRefusedNoWorkingDay: 'В этом отпуске нет рабочего дня, который можно сократить.',
        impactRefusedDaysDiffer: 'Сохранённое число дней не совпадает с датами, сначала исправьте отпуск.',
        impactRefusedMustTake: 'Это единственный 10-дневный ежегодный отпуск, и в этом году больше нет возможности взять 10 дней.',
        confirmedAdminOnly: '{{year}} год подтверждён, поэтому менять его праздники может только администратор.', confirmYear: 'Подтвердить {{year}}', yearConfirmed: 'Подтверждено', yearUnconfirmed: '{{year}} не подтверждён',
        copyYear: 'Скопировать праздники {{year}}', copiedCheckDate: 'Та же дата, что в {{year}}, проверьте', copiedMark: 'Проверить дату',
        copyYearDone: 'Скопировано праздников из {{year}}: {{count}}. Проверьте даты и подтвердите.', copyYearSkipped: 'Пропущено: {{days}}',
        nationalHoliday: 'Гос. праздник', companyHoliday: 'Корпоративный выходной', weekend: 'Выходные',
        holidaysOf: 'Праздники · {{month}} {{year}}', noHolidays: 'В этом месяце праздников нет.',
        holidayName: 'Название праздника', removeHoliday: 'Удалить праздник',
        yearNotImported: 'Календарь на {{year}} не импортирован — выходные действуют, праздники нужно внести вручную.',
        calendarSaved: 'Календарь сохранён', calendarReset: 'Календарь возвращён к импортированному списку',
        summaryNational: 'Гос. праздники за {{year}}', summaryCompany: 'Корпоративные выходные за {{year}}',
        summaryWorkdays: 'Рабочие дни за {{year}}',
        tabTimeLogging: 'Табель', tabLeave: 'Отпуск',
        statPendingDays: 'Дней на рассмотрении', statRejectedDays: 'Отклонённых дней',
        statPendingRequests: 'Заявок на рассмотрении',
        cutOffDay: 'Отсечка по зарплате', cutOffMark: 'Отсечка',
        cutOffsNearby: 'Отсечки по зарплате', holidaysNearby: 'Праздники',
        listPrevious: 'Предыдущие', listUpcoming: 'Ближайшие',
        noCutOffsNearby: 'Рядом с этим месяцем зарплатные периоды ещё не созданы.',
        noHolidaysNearby: 'Рядом с этим месяцем праздников нет.',
        paysOn: 'выплата {{date}}',
        // A product's uses, moving them, deleting it.
        uses: 'Использование',
        usageTitle: 'Использование {{product}}',
        usageLoading: 'Подсчёт…',
        useNone: 'Этот продукт нигде не используется — его можно удалить.',
        useLines: 'Строк учёта времени: {{count}}',
        useRoles: 'Ролей сотрудников на продукте: {{count}}',
        usePlannedDays: 'Плановых дней графика: {{count}}',
        useActualDays: 'Фактических дней графика: {{count}}',
        useLogDays: 'Записанных дней графика: {{count}}',
        useExternalProjects: 'Карточек подрядчиков с ним как проектом: {{count}}',
        useRosterCells: 'Ячеек графика под его монгольским названием: {{count}}',
        usageSpan: 'Заполняли {{people}} чел., {{first}} – {{last}}.',
        usageClosedLines: 'Из них {{count}} строк в закрытых расчётных месяцах.',
        usageRosterRow: 'В графике как «{{name}}».',
        showPeople: 'Кто заполнял',
        hidePeople: 'Скрыть людей',
        colPerson: 'Сотрудник',
        colDays: 'Дни',
        colHours: 'Часы',
        colSpan: 'Первый – последний день',
        moveTitle: 'Перенести это использование на другой продукт',
        moveHint: 'Все строки, роли и названия проекта переходят на выбранный продукт. Строки, у которых в тот же день уже есть такая же строка, складываются с ней. Выберите продукт, чтобы сначала увидеть количество.',
        moveRefusedAhead: '{{count}} строк в закрытых расчётных месяцах, а у выбранного продукта отличаются: {{settings}}. Перенос изменил бы закрытую зарплату, поэтому он будет отклонён. Выберите продукт с теми же настройками или выведите этот из использования.',
        typicalShiftHours: 'Типичная длина смены', pickProduct: 'Выберите продукт…',
        movePreviewLines: '{{lines}} строк переходят на {{target}}; {{merged}} из них складываются с существующей строкой.',
        movePreviewRoles: '{{moved}} ролей переносятся; {{skipped}} отбрасываются, так как у человека уже есть роль на выбранном продукте.',
        movePreviewCopies: '{{days}} дней графика и {{records}} карточек получают новое название проекта.',
        moveRosterMoved: 'Его запись в графике переходит на выбранный продукт.',
        moveRosterDropped: 'У выбранного продукта своя запись в графике, поэтому эта удаляется.',
        confirmMove: 'Перенести',
        moved: 'Всё использование {{source}} перенесено на {{target}}',
        deleteProductHint: 'Продукт больше нигде не используется. Удаление необратимо.',
        deleteProductBlocked: 'Удалить можно, только когда продукт нигде не используется — сначала перенесите использование выше или выведите его из использования флажком «Активен».',
        deleteProduct: 'Удалить продукт',
        confirmDeleteProduct: 'Удалить навсегда',
        productDeleted: '{{product}} удалён',
      },
  },
}
